export const subtitles = {
    "1": {
        "startTime": 14.95,
        "endTime": 23.45,
        "transcript": "Umyuarniuyaraq-llu nalluvkenaki, 16, nasaurlullraulua ceńirtaarteńgulua.",
        "translation": "And I knew about worry, 16, as a girl I would be the one to go to each house."
    },
    "2": {
        "startTime": 23.635,
        "endTime": 28.785,
        "transcript": "Tuaten tang umyuarteqnaurtua. Tua-i-ll' caqerlua angerlua.",
        "translation": "I would think that. Then one day, I agreed."
    },
    "3": {
        "startTime": 30.425,
        "endTime": 35.905,
        "transcript": "Aren, maaten tua-i aipaqsagutaqa tang aipaqa takaqluku.",
        "translation": "Oh my, I married him and found that I was reserved towards him out of respect."
    },
    "4": {
        "startTime": 37.01,
        "endTime": 41.13,
        "transcript": "Inartaqlua waten aklutuumarma caniani.",
        "translation": "I would lay next to him like this with all of my clothes."
    },
    "5": {
        "startTime": 41.875,
        "endTime": 47.405,
        "transcript": "Iciw' u͡gayarluteng maa-i gown-arluteng caluteng inartelallinilriit.",
        "translation": "You know, they take off their clothes and put on gowns or something to go to bed now."
    },
    "6": {
        "startTime": 47.495,
        "endTime": 52.715,
        "transcript": "Aklutuumarma wii inarrnaurtua caniani tuam aipama.",
        "translation": "I would go to bed by my spouse with all of my clothes."
    },
    "7": {
        "startTime": 52.96,
        "endTime": 60.75,
        "transcript": "Atam ilamnun-am uani uanlata kiani-ll' taukut uika tua-i kiani",
        "translation": "You see, I would go to my family out there and my husband was inside"
    },
    "8": {
        "startTime": 61.01,
        "endTime": 64.77,
        "transcript": "Kiugkut [?] iciw' piani avtaalriit.",
        "translation": "In there [?] you know the ones that split up there."
    },
    "9": {
        "startTime": 64.795,
        "endTime": 70.705,
        "transcript": "Ilamnun anelrarqama meglartua, iciw' utercuumiinii.",
        "translation": "When I would go downriver to my family, I would not want to go back, you know, not want to return."
    },
    "10": {
        "startTime": 70.725,
        "endTime": 74.115,
        "transcript": "Aanama pingnauraanga, \"Ampi uterten.\"",
        "translation": "My mother would say to me, \"Go back already.\""
    },
    "11": {
        "startTime": 74.695,
        "endTime": 82.065,
        "transcript": "Tua-i taqsuq'ngaqama anlua. Umyuaqa-w' tua-i Kass'at apqiitnek smash.",
        "translation": "I would go out when I was tired. My mind would be smashed as they say in English."
    },
    "12": {
        "startTime": 82.415,
        "endTime": 86.015,
        "transcript": "Itra'urlulalrianga taukunun uimnun.",
        "translation": "Poor me, I would go upriver to my husband's house."
    },
    "13": {
        "startTime": 86.21,
        "endTime": 97.19,
        "transcript": "Iteryartuarnaurtua tang nepa͡itqapiarluni. Iternartua ak'a inartellrullinilria. Takaipaa-ll' wangni. Takaitellrullinivaa.",
        "translation": "I would go in and it would be completely silent.  I would go in and he had already gone to bed. I was so disrespectful. I was so disrespectful."
    },
    "14": {
        "startTime": 97.705,
        "endTime": 106.035,
        "transcript": "Tua-i-ll' tua-i nallunrilkamku waniw' aipaqa inangqiin canianun tua-i aklutuumarma-ll' inarrlua.",
        "translation": "And since I knew that my husband was laying there, I would lay next to him with all of my clothes."
    },
    "15": {
        "startTime": 106.325,
        "endTime": 110.36,
        "transcript": "Aren, aipaqsagutellemni-ll' tua-i aqviitnga itertua tang",
        "translation": "Ooh my, when I married and they got me, I would go in"
    },
    "16": {
        "startTime": 110.36,
        "endTime": 119.89,
        "transcript": "Mat'um nalliini angun nulirtulartuq camek-llu tauna arnani cikirpek'naku aipaa.",
        "translation": "These days, a man takes a wife without giving anything to his wife."
    },
    "17": {
        "startTime": 120.48,
        "endTime": 123.79,
        "transcript": "Maaten tang itertua ak'a pitullruyugnarqut.",
        "translation": "I went in, I think they used to do it a long time ago."
    },
    "18": {
        "startTime": 123.83,
        "endTime": 127.59,
        "transcript": "Ukuk tang yassigpallraak kalikaak.",
        "translation": "There were two huge cardboard boxes."
    },
    "19": {
        "startTime": 128.025,
        "endTime": 137.915,
        "transcript": "Tua-i-ll' tang au͡g'um nasaurluum taum uima angnaan yuan tuaken tang anciaqluni taum aaniita tang tua-i inglera.",
        "translation": "And then that girl, my husband's older brother's child, would take something out, their mother's mattress."
    },
    "20": {
        "startTime": 137.915,
        "endTime": 143.965,
        "transcript": "Ingelret tang aklukegtaarait ulikegtaaraat nutararrlainaat.",
        "translation": "They were beautiful accessories for beds, all new blankets."
    },
    "21": {
        "startTime": 143.965,
        "endTime": 147.435,
        "transcript": "Tua-i beginning-aaqatarlua.",
        "translation": "That was the start of my beginning."
    },
    "22": {
        "startTime": 148.975,
        "endTime": 152.335,
        "transcript": "Tuaten pitullruut aklirluki.",
        "translation": "They would give things like that."
    },
    "23": {
        "startTime": 152.34,
        "endTime": 158.34,
        "transcript": "Tuaken tang kalikagnek taum nasaurluum cikirtungkilia canek.",
        "translation": "That girl started giving me things from those boxes."
    },
    "24": {
        "startTime": 158.465,
        "endTime": 163.865,
        "transcript": "Cikiraanga-llam anciluni atkugmek, fur parka.",
        "translation": "She took out and gave me an atkuk, a fur parka."
    },
    "25": {
        "startTime": 164.48,
        "endTime": 168.27,
        "transcript": "Iciw' mat'um nalliini fur parka-t expensive.",
        "translation": "You know that fur parkas are expensive these days."
    },
    "26": {
        "startTime": 168.86,
        "endTime": 170.98,
        "transcript": "Takarnaqluteng-llu.",
        "translation": "And they were overwhelming."
    },
    "27": {
        "startTime": 171.065,
        "endTime": 176.895,
        "transcript": "Atkugmek-am cikiqilia, canimnun-llu elliluk' tua-i wii quyavkenii.",
        "translation": "She gave me a parka, put it next to me, and I wasn't thankful."
    },
    "28": {
        "startTime": 176.955,
        "endTime": 180.175,
        "transcript": "Iciw' tua-i uingyuumiicaaqlua.",
        "translation": "You know, I didn't want a husband."
    },
    "29": {
        "startTime": 180.24,
        "endTime": 186.6,
        "transcript": "Cali-am pirraarluni anciuq piluguuk, fur mukluks.",
        "translation": "After that, she also took out piluguuk (2), fur mukluks."
    },
    "30": {
        "startTime": 187.595,
        "endTime": 189.965,
        "transcript": "Tegulukek canimnun ellilukek.",
        "translation": "She took them and put them next to me."
    },
    "31": {
        "startTime": 190.175,
        "endTime": 195.355,
        "transcript": "Tang carugaat tuaten pilua.",
        "translation": "She did that with many things."
    },
    "32": {
        "startTime": 197.04,
        "endTime": 198.3,
        "transcript": "Tua-i.",
        "translation": "There you go."
    },
    "33": {
        "startTime": 199.465,
        "endTime": 205.445,
        "transcript": "Tua-i-llu aipaqa tuani ilamini tuaten pillrunrituq.",
        "translation": "And then, my husband didn't do that with his family like that."
    },
    "34": {
        "startTime": 206.57,
        "endTime": 214.15,
        "transcript": "Uksuarmi tegullruatnga. Up'nerkaquani ilamnun-am meglua. Tuaten pilallruunga.",
        "translation": "They took me in the fall. The next spring, I wanted to be with my family. I used to do that."
    },
    "35": {
        "startTime": 214.155,
        "endTime": 221.755,
        "transcript": "Megngama-ll' tua-i taum aiparma upaucugyaaqlua Up'nerkillernun pingaunii.",
        "translation": "And when I wanted to go home, my husband wanted to move me to Up'nerkilleq, but I refused."
    },
    "36": {
        "startTime": 221.87,
        "endTime": 224.55,
        "transcript": "Unillua tayim' ayagluni.",
        "translation": "He left without me."
    },
    "37": {
        "startTime": 225.665,
        "endTime": 230.165,
        "transcript": "Tua-i-llu tua-i wii angnirilua ilamni.",
        "translation": "And then I became happy with my family."
    },
    "38": {
        "startTime": 230.7,
        "endTime": 239.83,
        "transcript": "Tekilluni up'nerkami ukut qanertut tauna-gguq, taum-gguq uima ullakataraanga move-arluni family-mnun.",
        "translation": "He came in the spring, and they told me that my husband was going to come and move in with my family."
    },
    "39": {
        "startTime": 240.27,
        "endTime": 245.62,
        "transcript": "Tua-i tuaten pillarani wiinga iciw' quyalua.",
        "translation": "When he did that, I was, you know, thankful."
    },
    "40": {
        "startTime": 245.64,
        "endTime": 250.04,
        "transcript": "Ima tanem aanama pilallrukiinga, \"Castekaqerput.\"",
        "translation": "That's right, my mother would tell me, \"He will provide for us.\""
    },
    "41": {
        "startTime": 250.145,
        "endTime": 254.015,
        "transcript": "Tua-i-w' move-arluni tailuni waniw' aulukqataqiikut.",
        "translation": "He was going to come and move to take care of us."
    },
    "42": {
        "startTime": 254.055,
        "endTime": 263.385,
        "transcript": "Tuaten tua-i nallunrilama iciw' tua-i assirluku tang imkunga'arrluku, tunusngaurluku-ll' uitalallruama.",
        "translation": "Because I knew that, you know, I started treated him well, also because I would keep my back to him before."
    },
    "43": {
        "startTime": 263.635,
        "endTime": 269.895,
        "transcript": "Iliini-ll' tua-i tangerrsaurrluku. Takarnaqpiarluni.",
        "translation": "And I started looking at him sometimes. He was very intimidating."
    },
    "44": {
        "startTime": 270.05,
        "endTime": 274.3,
        "transcript": "Takaqucetullrulliut. Wiinga-w' tuaten pillrulrianga.",
        "translation": "They must have respected each other. I, at least, did that."
    },
    "45": {
        "startTime": 298.93,
        "endTime": 302.56,
        "transcript": "Tua-i-llu move-arlun' wangkutnun.",
        "translation": "And then he moved in with us."
    },
    "46": {
        "startTime": 303.17,
        "endTime": 305.92,
        "transcript": "Aren-llam qinganrilngua egmian.",
        "translation": "Oh my, I didn't get pregnant right away."
    },
    "47": {
        "startTime": 305.94,
        "endTime": 311.22,
        "transcript": "Agturcecuilama tuaten inartelaama ellaka man' eqluku.",
        "translation": "Because I wouldn't let him touch me as I went to bed and closed off my mind."
    },
    "48": {
        "startTime": 311.535,
        "endTime": 318.715,
        "transcript": "Iliini-llu unuakumi aanama pilaraanga waten: \"Yagleralanrilu.\"",
        "translation": "And some mornings, my mother would say this to me: \"Do not suddenly raise your hand.\""
    },
    "49": {
        "startTime": 318.92,
        "endTime": 325.31,
        "transcript": "Aipaagni tang iciw' angutet maa-i nallunirtut arnat yagiratulliut qaillun.",
        "translation": "You know, men probably know that women raise their hands in certain ways."
    },
    "50": {
        "startTime": 326.19,
        "endTime": 335.31,
        "transcript": "Iliini waten tallini taitaqaku wiinga waten assiilkelluku piaqluku.",
        "translation": "Sometimes when he brought his arm like this, I would do this out of dislike for him."
    },
    "51": {
        "startTime": 335.415,
        "endTime": 339.755,
        "transcript": "Aanama, \"Piyuitut tuaten.\" Nalluama-wa.",
        "translation": "My mother would say, \"They don't do that.\" I didn't know."
    },
    "52": {
        "startTime": 341.2,
        "endTime": 346.66,
        "transcript": "Ayuqucirtuun, rule-angqelliniut cat tamarmeng.",
        "translation": "Everything has ayuqucirtuutet, rules."
    },
    "53": {
        "startTime": 347.065,
        "endTime": 349.295,
        "transcript": "Piyuitut-gguq tuaten.",
        "translation": "She said they don't do that."
    },
    "54": {
        "startTime": 349.555,
        "endTime": 354.225,
        "transcript": "Angun-gguq nulirtulartuq naanguarkaminek.",
        "translation": "She said a man takes a wife for fun."
    },
    "55": {
        "startTime": 355.245,
        "endTime": 357.885,
        "transcript": "Tua-i alingallagnaurtua.",
        "translation": "I would be hit with fear."
    },
    "56": {
        "startTime": 358.05,
        "endTime": 362.26,
        "transcript": "Tua-i-ll' tang qingarlua Robert Nick, Yuukamek pia-i.",
        "translation": "And then I was pregnant with Robert Nick, Yuukaq, who's inland."
    },
    "57": {
        "startTime": 362.55,
        "endTime": 369.68,
        "transcript": "Qinganglua. Qingangellemni tang nutaan uika tauna cauluku-ll' caumayaurtellrukeka.",
        "translation": "I got pregnant. When I was pregnant, I could finally face my husband for long periods of time."
    },
    "58": {
        "startTime": 370.99,
        "endTime": 374.59,
        "transcript": "Aspiallinivaa-ll' Nick-ami.",
        "translation": "Nick turned out to be very good."
    },
    "59": {
        "startTime": 375.645,
        "endTime": 383.205,
        "transcript": "Tua-i-llam tuaten qinganglua nutaan murilkessaurtellruaqa Bible-aanek, Bible.",
        "translation": "And then when I was pregnant like that, I finally started observing him reading the Bible."
    },
    "60": {
        "startTime": 383.62,
        "endTime": 388.75,
        "transcript": "Una tang tauna uika calilgupiaq.",
        "translation": "My husband was always working hard."
    },
    "61": {
        "startTime": 389.21,
        "endTime": 395.9,
        "transcript": "Tua-i cunaw' hard worker-aarullinilria angayuqaagma cucukellrak.",
        "translation": "The one my parents chose turned out to be a hard worker."
    },
    "62": {
        "startTime": 397.97,
        "endTime": 404.2,
        "transcript": "Bible-aaliurturyaurrluni. Bible-aanek-am naaqiurnaurtuq every evening.",
        "translation": "He started reading the Bible. He would read the Bible every evening."
    },
    "63": {
        "startTime": 405.65,
        "endTime": 410.83,
        "transcript": "Malruurrlutek-ll' irniapuk, Robert, Margaret piyugnarquk.",
        "translation": "Then we had two childrenb, Robert and Margaret I think."
    },
    "64": {
        "startTime": 411.035,
        "endTime": 414.005,
        "transcript": "Pastor-aarurrluni young.",
        "translation": "He became a pastor at a young age."
    },
    "65": {
        "startTime": 415.715,
        "endTime": 421.315,
        "transcript": "Aspialliniuq. Qaneryugngaunga assillranek.",
        "translation": "It's very nice. I can say how nice it is."
    },
    "66": {
        "startTime": 422.255,
        "endTime": 426.275,
        "transcript": "Aquiyuunani. Aquilallruukut.",
        "translation": "He wouldn't frolick. We used to frolick."
    },
    "67": {
        "startTime": 426.41,
        "endTime": 431.61,
        "transcript": "Maa-i aquivigtangqertut like Teen Center, allat-llu.",
        "translation": "Now, there are places to play like the Teen Center, and others."
    },
    "68": {
        "startTime": 432.265,
        "endTime": 436.835,
        "transcript": "Aquilallemni-ll' tauna uikaqa tangerqayuunaku.",
        "translation": "When I would play in them, I would never see the one who'd become my husband."
    },
    "69": {
        "startTime": 438.185,
        "endTime": 444.665,
        "transcript": "Tuaten tang ayagmek ayuqellinian angayuqaagma pikesqellrullinikiik.",
        "translation": "Since he was like that from the beginning, my parents wanted me to be with him."
    },
    "70": {
        "startTime": 445.98,
        "endTime": 449.23,
        "transcript": "Bible-aaliurturyaurrluni-am tua-i.",
        "translation": "He started reading the Bible."
    },
    "71": {
        "startTime": 449.23,
        "endTime": 455.52,
        "transcript": "Ak'anivekenaku-ll' pastor-aarurrluku. Young-arluni pastor-aarurtellruuq Nunapicuarmi.",
        "translation": "And before long, they made him a pastor. He became a pastor in Nunapitchuk at a young age."
    },
    "72": {
        "startTime": 455.86,
        "endTime": 460.2,
        "transcript": "Ava-i-ll' tua-i pastor-aaruinanermini tuquluni.",
        "translation": "And he just died as he was still a pastor."
    },
    "73": {
        "startTime": 461.585,
        "endTime": 463.815,
        "transcript": "Nine-aanek-ll' irnianglunuk.",
        "translation": "And we had nine children."
    },
    "74": {
        "startTime": 464.505,
        "endTime": 468.035,
        "transcript": "Angli-ll' tang tuaten piyullrullinivaa.",
        "translation": "Wow, he was so dedicated to that."
    },
    "75": {
        "startTime": 468.675,
        "endTime": 474.625,
        "transcript": "Pastor-aarinanermini-ll' ping'umek kipusviggarmek pililuni.",
        "translation": "And as he was a pastor, he built that little store inland."
    },
    "76": {
        "startTime": 474.785,
        "endTime": 486.045,
        "transcript": "Pilivailegmi ciumek agayulirtet, Moravian-aat agayulirtait ullagnillrui, Kuigglugmi-llu-gguq agayilirta ullagluku.",
        "translation": "Before he made it, he said that he first went to the pastors, the Moravian pastors, and went to the pastor in Kwethluk."
    },
    "77": {
        "startTime": 488.55,
        "endTime": 493.65,
        "transcript": "Nallunritqapiar elitna͡ungssagaunani-ll'.",
        "translation": "He was extremely knowledgable with absolutely no Western education."
    },
    "78": {
        "startTime": 494.975,
        "endTime": 503.275,
        "transcript": "Apqaullinia-am tamakut pastor-aarinanermini kipusvik inglukluku calillerkaminek.",
        "translation": "He asked if he could work at the store alongside being a pastor."
    },
    "79": {
        "startTime": 503.61,
        "endTime": 506.66,
        "transcript": "Tamakut-llu tua-i okay-lliniluku.",
        "translation": "And they gave him the okay."
    },
    "80": {
        "startTime": 506.78,
        "endTime": 517.13,
        "transcript": "Tamakunun tau͡gaam ellangcarraarluni pia-i pingna piliaruuq, Nick O. Nick Trading Post, agayulirteńun makunun elisngalrianun.",
        "translation": "That building inland, Nick O. Nick Trading Post, was built only after being reviewed by the knowledgable priests here."
    },
    "81": {
        "startTime": 543.73,
        "endTime": 551.05,
        "transcript": "Tua-i-ll' ava-i tuaten irniapuk anglicarluki.",
        "translation": "And then we raised our children like that."
    },
    "82": {
        "startTime": 552.225,
        "endTime": 557.115,
        "transcript": "Taangaq-ll' ataucirquungraan waten piksaunaku.",
        "translation": "And we never did this even once with alcohol."
    },
    "83": {
        "startTime": 557.365,
        "endTime": 563.485,
        "transcript": "Akmavet ayalallruukuk qavcirqunek kipusvingumariluku.",
        "translation": "We used to travel over to the city several times after he had built the store."
    },
    "84": {
        "startTime": 566.4,
        "endTime": 574.08,
        "transcript": "Elitna͡ungssagaileng'e'rmi ilii smart-apialliniuq, elisngaq'apiarararkauluni.",
        "translation": "Some are very smart, are destined to be smart, even if they have absolutely no Western education."
    },
    "85": {
        "startTime": 574.915,
        "endTime": 580.775,
        "transcript": "Waniw' wiinga nanrarpek'naku cuqyutkuurluku qalartua.",
        "translation": "I am not praising him, but speaking of him as an example."
    },
    "86": {
        "startTime": 582.8,
        "endTime": 592.5,
        "transcript": "Akmavet ayalallmegni Kass'at mat'um nalliini yugnikutek'lalliniat taangarraq.",
        "translation": "When we used to go to the city, it turned out that Caucasians use a little alcohol in their friendly social interactions."
    },
    "87": {
        "startTime": 593.025,
        "endTime": 597.445,
        "transcript": "Tua-i una-ll' itran, \"You want a drink?\"",
        "translation": "And then when someone comes in, \"You want a drink?\""
    },
    "88": {
        "startTime": 599.08,
        "endTime": 608.07,
        "transcript": "Akmani business-aalegni calillgutaini tarritelallruukuk.",
        "translation": "We would go around over there in his colleagues' businesses."
    },
    "89": {
        "startTime": 608.31,
        "endTime": 615.66,
        "transcript": "Tua-i-ll' igvaamnuk tua-i arenqiarraarluni, \"Nick, you want a drink?\" pilallruat. \"No.\"",
        "translation": "And when we came in after he made himself comfortable, \"Nick you want a drink?\" they would ask him. \"No.\""
    },
    "90": {
        "startTime": 616.28,
        "endTime": 620.82,
        "transcript": "No-raqan atam sorry-lalriit imkut elisngapiat.",
        "translation": "When he said \"No,\" the smart ones would say, \"Sorry.\""
    },
    "91": {
        "startTime": 621.835,
        "endTime": 623.905,
        "transcript": "\"I'm sorry, Nick.\"",
        "translation": "\"I'm sorry, Nick.\""
    },
    "92": {
        "startTime": 624.2,
        "endTime": 631.69,
        "transcript": "Pirraarluku-ll' kingunertaqluku, \"Nick, you're lucky.\" Tuaten-llu piaqluku.",
        "translation": "After that, they would say afterwards, \"Nick, you're lucky.\" They would say that to him."
    },
    "93": {
        "startTime": 632.54,
        "endTime": 638.46,
        "transcript": "Qalarutkanka makut qanenrilnguarngailama assilriaruata.",
        "translation": "I will not keep from speaking about what I said because they're good."
    },
    "94": {
        "startTime": 664.495,
        "endTime": 673.155,
        "transcript": "Waten uksuarmi qau͡gani Kialirmi tan'gaurluullemteńi",
        "translation": "When we were boys in the fall like this upriver in Kialiq"
    },
    "95": {
        "startTime": 673.56,
        "endTime": 680.43,
        "transcript": "Kiani Kialiim paingani Qukaqlircaramek-gguq uumek aterluni kuiggar au͡gna.",
        "translation": "They said that the creek upriver at the mouth of Kialiq was named Qukaqlircaraq."
    },
    "96": {
        "startTime": 680.6,
        "endTime": 684.86,
        "transcript": "Tuani tua-i uitalallruukut.",
        "translation": "We used to live there."
    },
    "97": {
        "startTime": 685.755,
        "endTime": 696.355,
        "transcript": "Makut tau͡gken aulukesteput waten uksuarmi uitaurallrunritut.",
        "translation": "But our caretakers would not live in the same area in the fall like this."
    },
    "98": {
        "startTime": 697.96,
        "endTime": 705.23,
        "transcript": "Wall'u cali uitaurluteng waten ayagayuitellruluteng.",
        "translation": "Or, they would also stay in one area like this without traveling."
    },
    "99": {
        "startTime": 705.647,
        "endTime": 719.747,
        "transcript": "Makut maa-i uksuarmun atulriit waten agaaken neqlillernek taigaqameng uksuarmi",
        "translation": "Towards fall, when they came from the fish camps across there in the fall"
    },
    "100": {
        "startTime": 720.886,
        "endTime": 724.858,
        "transcript": "Muragnek quyurtetullruut.",
        "translation": "They would gather wood."
    },
    "101": {
        "startTime": 725.221,
        "endTime": 730.192,
        "transcript": "Angyaunateng-llu tau͡gaam qayatgun.",
        "translation": "And they didn't have boats, but traveled by kayak."
    },
    "102": {
        "startTime": 730.24,
        "endTime": 745.183,
        "transcript": "Unuakumi waten uksuarmi ulerpagangetuan unuakuarmi tan'germi tayima ayagangtullruut.",
        "translation": "Since the tide would come in high in the morning during fall, they would start traveling in the morning in the dark."
    },
    "103": {
        "startTime": 745.533,
        "endTime": 757.461,
        "transcript": "Tua-i tau͡gken iliini uaggun Cingigkun igvarnaurtuq iliini qayaq nangcarluni muragnek.",
        "translation": "Sometimes, however, a kayak would appear through Cingik downriver towing wood behind."
    },
    "104": {
        "startTime": 759.548,
        "endTime": 778.419,
        "transcript": "Tua-i tamaa-i tamakut waten uksuarmi maavet kuiget kangritnun ayakata'arqameng uksuiyaqatarqameng tamakunek tamaa-i quyurtetullruut.",
        "translation": "During the fall like this, when they were going to go the headwaters of rivers to their winter camps, they would gather those."
    },
    "105": {
        "startTime": 780.576,
        "endTime": 790.434,
        "transcript": "Au͡gkut ciuqliput anglicartelput wangkucicetun maanitun ayuqellrunritut.",
        "translation": "Our ancestors, those who raised us, were not like how we are here."
    },
    "106": {
        "startTime": 790.856,
        "endTime": 802.342,
        "transcript": "Ellmeggnek ang'aqualuteng tallimegteggun ayagaluteng merkun anguarturluteng pitullruut.",
        "translation": "They would travel by straining their own arms, rowing through the water."
    },
    "107": {
        "startTime": 802.734,
        "endTime": 813.763,
        "transcript": "Tua-i-llu nutaan pinarilliateng asgurangluteng.",
        "translation": "And when it was time for them, they started going upriver."
    },
    "108": {
        "startTime": 814.496,
        "endTime": 828.053,
        "transcript": "Imkut tamakut muriit itulluki nutaan-llu qaingit canek ucilirluki aklumeggnek.",
        "translation": "They would bring the wood with them, then put their possessions on top as cargo."
    },
    "109": {
        "startTime": 828.7,
        "endTime": 834.128,
        "transcript": "Angyailnguut muragteggun tua-i upatullruut.",
        "translation": "Those without boats would move with wood."
    },
    "110": {
        "startTime": 834.531,
        "endTime": 845.131,
        "transcript": "Tua-i-llu nutaan tekicameng kuiget kangritnun tamaavet uksuillerkameggnun muriit tamakut tageqluki.",
        "translation": "And then when they reached the headwaters of the rivers where they would camp for the winter, they would bring the wood inland."
    },
    "111": {
        "startTime": 845.31,
        "endTime": 860.281,
        "transcript": "Nutaan-llu upluteng. Muriit tamakut neqsuutekateng taluyarkateng upluki.",
        "translation": "Then they would prepare. They would prepare the wood to make their fishing implements, their fish traps."
    },
    "112": {
        "startTime": 884.813,
        "endTime": 891.699,
        "transcript": "Muriit imkut taluyarkiurluki, taluyarpagkiurluki pitullruit.",
        "translation": "They would make the wood into big fish traps."
    },
    "113": {
        "startTime": 892.774,
        "endTime": 903.674,
        "transcript": "Waten taluyarpiit ayuqetullruut. Paingit iqtuluteng, takluteng.",
        "translation": "Big fish traps were like this. Their openings were wide and long."
    },
    "114": {
        "startTime": 905.469,
        "endTime": 913.54,
        "transcript": "Waten-llu tua-i piluteng, ayuqluteng wagg'uq taukut tua-i ilulirpait.",
        "translation": "And they were like this, what they called the inner funnel."
    },
    "115": {
        "startTime": 913.615,
        "endTime": 922.201,
        "transcript": "Nutaan-llu ukut cali qukait cali taluyiluki waten qerrurluki.",
        "translation": "And then they would also make the middle of the fish traps by enlarging them like this."
    },
    "116": {
        "startTime": 922.277,
        "endTime": 928.177,
        "transcript": "Nutaan-llu yaaggun pingayuat piluku.",
        "translation": "And then they would set the third one over there."
    },
    "117": {
        "startTime": 928.713,
        "endTime": 935.898,
        "transcript": "Tamakut tamaa-i qamunek pitullruit taluyapiat.",
        "translation": "They called those original fish traps qamut."
    },
    "118": {
        "startTime": 936.127,
        "endTime": 943.642,
        "transcript": "Makut taluyarpiit pitun, can'giircuutetun ayuqellrunritut.",
        "translation": "These big fish traps were not like, you know, blackfish traps."
    },
    "119": {
        "startTime": 944.194,
        "endTime": 948.18,
        "transcript": "Waten-llu iciw' akultutaluteng.",
        "translation": "And, you know, their gaps were this wide."
    },
    "120": {
        "startTime": 948.203,
        "endTime": 956.66,
        "transcript": "Akultutarrluki, yaa, piciatun-am piveknaki tamakut taluyarpiit pitullruit.",
        "translation": "They made wide gaps, yes, they had a procedures to make those big fish traps."
    },
    "121": {
        "startTime": 957.197,
        "endTime": 968.154,
        "transcript": "Waten ukut cuq'errluki tua-i-llu imna cigyak elliluku, tuavet elliluku.",
        "translation": "After measuring these, they would put the split spruce, put it there."
    },
    "122": {
        "startTime": 968.169,
        "endTime": 978.655,
        "transcript": "Tua-i-ll' waten nutaan pirraarluku yaatiinun qaill' tua-i waten akultutarrluki tamakut taluyarpiit pitullruit.",
        "translation": "And then after doing this, they would make certain gaps like this on the side for those big fish traps."
    },
    "123": {
        "startTime": 980.824,
        "endTime": 988.367,
        "transcript": "Tua-i waten caliaqengaqamegteki unatmeggnek-llu nangutetullruut.",
        "translation": "When they started working on them like this, their hands would get raw."
    },
    "124": {
        "startTime": 988.446,
        "endTime": 995.874,
        "transcript": "Makut, ukut waten piurallrit pelacinagnek piyuunaki.",
        "translation": "They would use twine for the things they worked on like this."
    },
    "125": {
        "startTime": 995.891,
        "endTime": 1004.748,
        "transcript": "Tau͡gaam makunek cali muragnek qupurturluki amililuki mamkunaki",
        "translation": "Instead, they would thinly split these pieces of wood"
    },
    "126": {
        "startTime": 1004.758,
        "endTime": 1010.686,
        "transcript": "Qaillun tua-i waten iqtutaurluki tau͡gaam amililuki.",
        "translation": "There were about this wide, but thin."
    },
    "127": {
        "startTime": 1010.783,
        "endTime": 1020.769,
        "transcript": "Tamakut-am tua-i piciatun cali caliaqsuitellruit. Cuqerluteng qaillun mamtutacirkait.",
        "translation": "They also had procedures for making those. They measured the thickness."
    },
    "128": {
        "startTime": 1022.735,
        "endTime": 1030.992,
        "transcript": "Tuaten tua-i pingaqameng makuit nangtullruut ukut waten piurluki.",
        "translation": "When they started doing that, they become raw here from doing this."
    },
    "129": {
        "startTime": 1031.889,
        "endTime": 1044.132,
        "transcript": "Aunrangaqata tua-i imkunek qecignek caquliluki ukut pingayun pitullruit",
        "translation": "When they started bleeding, they would wrap these three with skin"
    },
    "130": {
        "startTime": 1044.821,
        "endTime": 1047.707,
        "transcript": "Nang'aqata makut.",
        "translation": "When these became raw."
    },
    "131": {
        "startTime": 1049.527,
        "endTime": 1055.47,
        "transcript": "Ukut-llu cali, ukut-llu nang'aqluteng tegumiaqurallrit.",
        "translation": "These too, these would get raw from gripping."
    },
    "132": {
        "startTime": 1056.557,
        "endTime": 1063.657,
        "transcript": "Au͡gkut ciuqliput-wa tua-i wangkucicetun waten ayuqellrunritut.",
        "translation": "Our ancestors back then were not like us."
    },
    "133": {
        "startTime": 1064.542,
        "endTime": 1070.385,
        "transcript": "Aklungqellruut, muragnek aklungqellruut.",
        "translation": "They had wooden possessions."
    },
    "134": {
        "startTime": 1070.4,
        "endTime": 1078.129,
        "transcript": "Tamaa-i tamakut aklukellruit muriit cassuutekluki.",
        "translation": "That wood was used for their possessions and tools."
    },
    "135": {
        "startTime": 1079.906,
        "endTime": 1089.82,
        "transcript": "Cakluki, enekluki, enemeggnun waten aklukluki, ikamraqluki-llu.",
        "translation": "They used for their things, houses, things around their houses, and sleds."
    },
    "136": {
        "startTime": 1090.122,
        "endTime": 1095.579,
        "transcript": "Tua-i cat aturluku una murak yuungnaqellruut.",
        "translation": "They survived by using this wood."
    },
    "137": {
        "startTime": 1122.954,
        "endTime": 1126.74,
        "transcript": "Kitak' tua-i ellangellemni qanruyutellemnek.",
        "translation": "Let me talk about the traditional wisdom I grew up with."
    },
    "138": {
        "startTime": 1126.78,
        "endTime": 1140.165,
        "transcript": "Ellangellruunga pau͡gani yuilqumi nunangqerraqluta wall' uani Tagyaram paingani nunangqerraqluta kiimeta.",
        "translation": "I grew up where we alone had a settlement inland in the wilderness or downriver at the mouth of Tagyaraq."
    },
    "139": {
        "startTime": 1140.609,
        "endTime": 1152.523,
        "transcript": "Kiagmi tau͡gaam neqlillerni tamaa-i nasaurluullemni tuaten ayuqellruukut pau͡gani yuilqumi uksuarmi uitaaqluta yugtaunani elatvut.",
        "translation": "But when I was a girl, we would be in the fish camps in the summer, then in the wilderness inland in the fall with no one around us."
    },
    "140": {
        "startTime": 1152.652,
        "endTime": 1157.623,
        "transcript": "Uani-ll' call' uksumi Tagyarami yugtaunani elatvut.",
        "translation": "And downriver at Tagyaraq in the winter, there was no one around us."
    },
    "141": {
        "startTime": 1157.668,
        "endTime": 1163.383,
        "transcript": "Tau͡gaam neqlillernun ayagaqamta nutaan yugnek tangengaqluta.",
        "translation": "But we would start seeing people when we went to fish camp."
    },
    "142": {
        "startTime": 1164.04,
        "endTime": 1172.912,
        "transcript": "Tua-ll' maurlumni wii uitalua maurluma anglicaraqnganga, maurluugma anglicaraqnganga.",
        "translation": "And I stayed with my grandmother because my grandmother raised me, because my grandparents raised me."
    },
    "143": {
        "startTime": 1173.258,
        "endTime": 1181.586,
        "transcript": "Ukugnek tau͡gken arnagnek cali ilalua. Ilakluta tua-i.",
        "translation": "However, I lived with two other women. We were a family."
    },
    "144": {
        "startTime": 1181.755,
        "endTime": 1193.97,
        "transcript": "Tua-i-ll' taum maurlurma qanrut'laraakut, unuakumi-llu inerqularaakut maktaqamta nakukut'laasqevkenata. Nakukuteksaunata pisqelluta.",
        "translation": "And then my grandmother would tell us and admonish us in the morning when we got up not to fight each other. She told us not to fight each other."
    },
    "145": {
        "startTime": 1194.051,
        "endTime": 1203.78,
        "transcript": "Tua-i ilarraquralriani wangkuta tuani enem iluani ilarraquralriani nakukucuunata ilakellruukut.",
        "translation": "We little family who were in that house did not fight as a small family."
    },
    "146": {
        "startTime": 1203.817,
        "endTime": 1211.146,
        "transcript": "Waten tua-i pilaraakut caqcaaralaasqelluta tau͡gaam ikayuqu'urluta nakukuteksaunata.",
        "translation": "She would tell us to instead do our chores and help each other without fighting."
    },
    "147": {
        "startTime": 1211.543,
        "endTime": 1221.215,
        "transcript": "Tua-i-ll' tamaavet ayiimta yugnun waten call' pilaraanga unuakumi anqata'arqama:",
        "translation": "And then when we went there to a populated place, she would also say this to me when I was going to go out in the morning:"
    },
    "148": {
        "startTime": 1221.235,
        "endTime": 1232.964,
        "transcript": "Kitaki-gguq nakukekatnga qakemkut, naanguaqumta-llu nakukekatnga qimakilii. Akinauryaqunii-gguq.",
        "translation": "If the people outside picked on me, and if they picked on me as we were playing, I should run awy. She told me not to retaliate."
    },
    "149": {
        "startTime": 1233.692,
        "endTime": 1236.935,
        "transcript": "Tuamta-ll' waten call' pilaraanga:",
        "translation": "Then she would also say this to me:"
    },
    "150": {
        "startTime": 1237.298,
        "endTime": 1249.769,
        "transcript": "Yuum-gguq pingraanga akinauryaqunaku tau͡gaam-gguq ilanka kenekluki, kenkurluki. Kenkurautelalta-gguq. Ilaput-llu-gguq tamalkuita kenkurluki.",
        "translation": "Even if a person wrongs me, do not retaliate, but I should treat all my peers with love, always with love. We should treat each other with love. She said we should treat all of our peers with love."
    },
    "151": {
        "startTime": 1250.748,
        "endTime": 1259.677,
        "transcript": "Tua-i tamaa-i nasaurluullemni, nasaurluullemteńi qalarut'laraakut qaillun ayuqellerkamteńek ernerpak.",
        "translation": "When I was a girl, when we were girls, she would speak to us about how we should behave for the day."
    },
    "152": {
        "startTime": 1259.711,
        "endTime": 1265.611,
        "transcript": "Taumek alikellruarput wangkuta nunurnganata qalarut'laakut.",
        "translation": "That why we feared her because it seemed that she was scolding us."
    },
    "153": {
        "startTime": 1265.935,
        "endTime": 1274.178,
        "transcript": "Qanruyutni nall'artenritqerqamteggu taum maurlurma nunurngatpiarluta qanpagalluta qalarutaqluta.",
        "translation": "When we didn't adhere to her wisdom, my grandmother would shout at us as if scolding us."
    },
    "154": {
        "startTime": 1274.413,
        "endTime": 1281.284,
        "transcript": "Taumek alikellruarput qanruyutiin uniurtaallerkaa.",
        "translation": "That's why we were scared of disregarding her wisdom."
    },
    "155": {
        "startTime": 1281.646,
        "endTime": 1290.389,
        "transcript": "Tua-i tuaten kenkutesqelluta alerqualaraakut, kenkuquraasqelluta ilaput-llu nakukeksaunaki.",
        "translation": "She would instruct us to treat each other with love like that, always treat each other with love and never fight our peers."
    },
    "156": {
        "startTime": 1290.757,
        "endTime": 1297.571,
        "transcript": "Yuum-llu pingraakut cali akilaasqevkenaku.",
        "translation": "And no matter what anyone does to us, never to retaliate."
    },
    "157": {
        "startTime": 1323.528,
        "endTime": 1329.699,
        "transcript": "Caliqcaaralaalta-gguq. Ullagtaarutevkenata-llu-gguq.",
        "translation": "She said that we should be hard working. She also said not to visit all the time."
    },
    "158": {
        "startTime": 1329.772,
        "endTime": 1336.372,
        "transcript": "Ullagtaaruskumta-ggua atam yugnun cangayuutekamteńun tekitniartukut.",
        "translation": "She said that if we visit people too much, we will get hurt someday."
    },
    "159": {
        "startTime": 1336.513,
        "endTime": 1341.498,
        "transcript": "Ullagtaarupakarluta-gguq cangayuutekamteńun tekiciiqukut.",
        "translation": "She said that if we visit too often, we will get hurt someday."
    },
    "160": {
        "startTime": 1341.716,
        "endTime": 1349.487,
        "transcript": "Tua-i-llu-gguq tuaten ceńirtaatukumta ullagtaarucukumta caurailngarciqukut-gguq.",
        "translation": "And then she said that if we visit other people too much, our things will deplete."
    },
    "161": {
        "startTime": 1349.539,
        "endTime": 1355.096,
        "transcript": "Calillerkamteńi-gguq ak'a caarkaput caurailngarciqaput.",
        "translation": "She said that our things will deplete when we should have been working."
    },
    "162": {
        "startTime": 1355.697,
        "endTime": 1371.868,
        "transcript": "Tuamta-llu-gguq calqurraq-gguq arnarrlainaungamta. Tamaani ellangellemni wiinga caranglluut makut can'get yuut teguyaraqellruit tupigturluki.",
        "translation": "And then she talked about little things since we are all women. Back when I was growing up, people would take these grass and weave them."
    },
    "163": {
        "startTime": 1373.679,
        "endTime": 1377.722,
        "transcript": "Neqauteteng caquliluki kiagmi.",
        "translation": "They would make containers for the fish they caught in the summer."
    },
    "164": {
        "startTime": 1378.348,
        "endTime": 1384.134,
        "transcript": "Taryaqviit-llu inglukeggluki iitallernek, iitallernek-llu caquluki.",
        "translation": "And they would pair king salmon and cover them with tall cottongrass."
    },
    "165": {
        "startTime": 1384.149,
        "endTime": 1392.249,
        "transcript": "Tamaa-i-gguq cumercuilkumta caqatallerput nallunaiciiquq: yaaken yaaqlimteńek iliiraaqluta.",
        "translation": "She said that if we do not prepare, it would be certain what we'll do: we will ask for things from our neighbors."
    },
    "166": {
        "startTime": 1392.709,
        "endTime": 1398.352,
        "transcript": "Inglukgutkaaramteńek iitallernek iitarcuilkumta iliiraaqluta.",
        "translation": "If we don't gather tall cottongrass to hang fish in pairs, we will ask for things."
    },
    "167": {
        "startTime": 1398.599,
        "endTime": 1405.814,
        "transcript": "Tua-i-gguq tamaa-i qelketailkumta iliirasteńguciqukut. Tuaten qanrut'lallruakut.",
        "translation": "She said that if we do not save things, we will be beggers. That's what she would tell us."
    },
    "168": {
        "startTime": 1406.111,
        "endTime": 1410.654,
        "transcript": "Arrsaullruukut. Ellangellemteńi cataunani.",
        "translation": "We were poor. There was nothing pre-made when we grew up."
    },
    "169": {
        "startTime": 1411.107,
        "endTime": 1422.064,
        "transcript": "Tuamtell' cali pinauraakut... tua-i waten mat'um nalliinitun ayuqellrunrituq ellangellemteńi. Wii arnassagapiarurteksaicaaqua.",
        "translation": "And then she would tell us... it was like how it is now when we were growing up. I haven't become an extremely old woman yet."
    },
    "170": {
        "startTime": 1422.51,
        "endTime": 1431.739,
        "transcript": "Tua-i tau͡gaam ellangellemni tamakut ak'allarnun taukunun ellangama ak'allapiatun ayuqngatellrulliniut.",
        "translation": "But when I was growing up, since I grew up with those old people, they seemed to be very old-fashioned."
    },
    "171": {
        "startTime": 1432.777,
        "endTime": 1439.363,
        "transcript": "Tuaten qanrut'laraakut. Qelketailkumta-gguq iliirasteńguciqukut.",
        "translation": "That's what she would tell us. If we don't save things, we will be beggers."
    },
    "172": {
        "startTime": 1441.063,
        "endTime": 1454.692,
        "transcript": "Mingqeqataqumta-llu-gguq, tang mat'um nalliini enurnaqsugnailngurmek, mingqeqataqumta-llu-gguq qelketailkumta yaaken yaaqlimteńek yualukarramteńek iliiraciiqukut.",
        "translation": "And she said that if we're going to see, see how it's not scarce these days, if we're going to sew and we do not save things, we will beg from our neighbors."
    },
    "173": {
        "startTime": 1455.241,
        "endTime": 1465.941,
        "transcript": "Wall'u-gguq mingqutmek-llu-gguq navrarciqliukut, wall'u-gguq iliiraciqukut qelketailkumta. Tang arrsaullrutacirput.",
        "translation": "Or she said that we might borrow even a needle, or we would beg if we didn't save things. That's how poor we were."
    },
    "174": {
        "startTime": 1466.631,
        "endTime": 1470.931,
        "transcript": "Taumek qanruyuteput qigcignarqellruut.",
        "translation": "That's why we respected the traditional wisdom passed down to us."
    },
    "175": {
        "startTime": 1499.019,
        "endTime": 1505.161,
        "transcript": "Neqalleruarmek tangerqumta, man'a ciuqliuguq neqalleruar.",
        "translation": "If we see a little fish, this little bit of fish is the first."
    },
    "176": {
        "startTime": 1505.331,
        "endTime": 1516.446,
        "transcript": "Neqalleruarmek tangerqumta ciuniuqilaut-gguq ikgelkevkenaku. Iniqerluku kinercirluku.",
        "translation": "If we see a little fish, she said that we should accept it without thinking it's too little. We should hang and dry it."
    },
    "177": {
        "startTime": 1516.54,
        "endTime": 1521.468,
        "transcript": "Tua-i-gguq tauna neqkaurciiquq iniqerluku kinerciqaqumteggu.",
        "translation": "She said that it would become food if we hang and dry it."
    },
    "178": {
        "startTime": 1522.167,
        "endTime": 1529.21,
        "transcript": "Waten kiagmi sek'arluku-gguq neqraq ataucirraungraan agarareskilaut.",
        "translation": "In the summer like this, she said that we should cut even a single little fish and hang it to dry."
    },
    "179": {
        "startTime": 1529.514,
        "endTime": 1534.171,
        "transcript": "Tua-i-llu-gguq kinqaku egamaarrlugarkaurciiqerput.",
        "translation": "And then she said that when it dries, we can eat it dried and boiled."
    },
    "180": {
        "startTime": 1534.247,
        "endTime": 1548.861,
        "transcript": "Tau͡gken-gguq ikgellekluku ilangcinrilkumteńi paralut-gguq nerluku, paralut caunrirluku, ciiviit anarluku, paralungluku-llu tua-i neqkaunrirluni.",
        "translation": "However, she said that if we think it's too little and ignore it, the worms will eat it, the worms will destroy it, flies lay eggs on it, and it will get worms so it's no longer edible."
    },
    "181": {
        "startTime": 1549.348,
        "endTime": 1551.919,
        "transcript": "Neqkaugarkaunrirluni.",
        "translation": "It will no longer be edible."
    },
    "182": {
        "startTime": 1551.936,
        "endTime": 1561.608,
        "transcript": "Taumek-gguq ikgelengraan ca neqalleruar qemagartaqluku pilaut. Neqkautuuq-gguq ikgelnge'rmi.",
        "translation": "That's why she said that we should store even a little bit of fish. She said it would be food even if it's not much."
    },
    "183": {
        "startTime": 1562.136,
        "endTime": 1565.079,
        "transcript": "Maa-i tuaten qanrutetullruakut.",
        "translation": "That's what they used to tell us."
    },
    "184": {
        "startTime": 1565.093,
        "endTime": 1579.279,
        "transcript": "Tuamta-llu pitsaqevkenani-gguq angussaagtengkumta arnarrlainaungamta, amllengrraan-gguq arnam neqkaq amrukenrilliu.",
        "translation": "And then she said that should we get a hunter, since we're all women, even if there's a lot of food to process, a woman should not be overwhelmed by them."
    },
    "185": {
        "startTime": 1580.043,
        "endTime": 1589.358,
        "transcript": "Amrukluku-gguq tua-i picuvlagluku pinrilliu. Pinqegcaarturluku-gguq kinerciarqiliu.",
        "translation": "She said that she shouldn't be overwhelmed and do a sloppy job. She said she should thoroughly dry it."
    },
    "186": {
        "startTime": 1589.472,
        "endTime": 1596.058,
        "transcript": "Maavet-llu-gguq neqallret tutmallernun pivkenaki, natmun tutmallrunrilngurmun ciqilluku.",
        "translation": "She also said not to dump food scraps to places where people trod, but to where people do not trod."
    },
    "187": {
        "startTime": 1596.098,
        "endTime": 1601.927,
        "transcript": "Tangniitut-gguq neqallret maani saggluteng cailkami.",
        "translation": "She said that food scraps are eyesores when they're a mess on the ground here."
    },
    "188": {
        "startTime": 1602.256,
        "endTime": 1609.799,
        "transcript": "Neqa-gguq piinani nangteqnarquq, anrutaq piinani. Maa-i tang makut qanruyutelput.",
        "translation": "She said we suffer without food, when the stomach has nothing. These are the wisdom passed down to us."
    },
    "189": {
        "startTime": 1611.036,
        "endTime": 1618.364,
        "transcript": "Apqucim-gguq tamarmi nalluunam atuyunailqaa anrutam piitellra.",
        "translation": "She said that it's worse having an empty stomach than any sickness."
    },
    "190": {
        "startTime": 1619.116,
        "endTime": 1623.159,
        "transcript": "Taumek-gguq neqalleruar, tua-i maa-i makut qanruyuteput.",
        "translation": "That's why even a little fish, this is our traditional wisdom."
    },
    "191": {
        "startTime": 1623.195,
        "endTime": 1629.495,
        "transcript": "Taumek-gguq neqalleruar yuunguitevkenaku assiilengraan-gguq qelkurluku.",
        "translation": "That's why she said not to despise a little fish even if it's bad, but to save it."
    },
    "192": {
        "startTime": 1629.508,
        "endTime": 1633.251,
        "transcript": "Assiilkingaitukut-gguq anrutarput piilkan.",
        "translation": "She said we won't dislike anything if our stomachs are empty."
    },
    "193": {
        "startTime": 1633.429,
        "endTime": 1637.571,
        "transcript": "Maa-i makut qanruyuteput ayagyuallemteńi.",
        "translation": "This is the traditional wisdom passed down to us when we were young."
    },
    "194": {
        "startTime": 1638.713,
        "endTime": 1645.399,
        "transcript": "Tuaten-llu tua-i neqalleruar sagcetevkenaku tutmallrunrilngurmun egtesqelluku.",
        "translation": "And she said not to litter with that little fish, but to throw it where people have not trod."
    },
    "195": {
        "startTime": 1645.762,
        "endTime": 1651.048,
        "transcript": "Caallugkuararput-llu neqlikumta tutmallrunrilngurmun egtesqelluku.",
        "translation": "And she told us to throw the slop from cutting fish to where people have not trod."
    },
    "196": {
        "startTime": 1651.171,
        "endTime": 1656.971,
        "transcript": "Neqalleruar-gguq yuum qemirrlukngani caassiksunaituq.",
        "translation": "She said that since a little fish is the backbone of a person, it should not be disregarded."
    },
    "197": {
        "startTime": 1657.21,
        "endTime": 1660.624,
        "transcript": "Assiilkiurluta-llu neresqevkenata.",
        "translation": "She also told us to eat without disliking anything."
    },
    "198": {
        "startTime": 1661.449,
        "endTime": 1670.521,
        "transcript": "Tua-i-gguq neqa piilkan assiilkiurngaitukut, cangakiurngaitukut ilumun yuk kaikuni cangakingailami.",
        "translation": "She said that if food is scarce, we will not dislike or reject anything, since a person truly will not reject anything if he is hungry."
    },
    "199": {
        "startTime": 1693.312,
        "endTime": 1706.64,
        "transcript": "Yaa, tamaani ellangeqaarraallemteńi waten yuk naulluuluni nangteqluni piluni tuquarkauluni tua-i piaqan",
        "translation": "Well, back when we were growing up, when a person was suffering in sickness and was on the verge of death"
    },
    "200": {
        "startTime": 1707.0,
        "endTime": 1712.371,
        "transcript": "Tamaa-i yuut-llu ellamek iternanritullrulriakuk enemun tuavet.",
        "translation": "We people would stop going into that house from outside."
    },
    "201": {
        "startTime": 1712.56,
        "endTime": 1720.4,
        "transcript": "Tua-i-llu tauna yuk nangtequmarraarluni ak'anun pinillruameng au͡gkut ciuqlimta kemgit",
        "translation": "And then after that person was sick for a long time, since our ancestors' bodies were strong back then"
    },
    "202": {
        "startTime": 1720.922,
        "endTime": 1729.906,
        "transcript": "Tuqukan aulukestain upluku maaken tua-i naken atrarrluku kanavet.",
        "translation": "When he died, his caretakers would prepare him, taking him down from somewhere here."
    },
    "203": {
        "startTime": 1730.306,
        "endTime": 1746.749,
        "transcript": "Aturarluku atkuinek at'elluku, ilait ivrucirluki, ilait-ll' iqertagluki, ilait-ll' angutngukan imarnitegnek at'elluki, ilait arillugluki, ilait aliimacirluki.",
        "translation": "They would clothe them, put on their parkas, some of them boots, some of them sealskin boots, put some seal gut rain parkas on some of the men, some of them fish skin gloves, and some of them fur gloves."
    },
    "204": {
        "startTime": 1746.912,
        "endTime": 1760.141,
        "transcript": "Kanavet wavet aqumlluki maktacirluki muragagnek. Aqumluteng tua-i waten piqertelluku kegginaa manimavkarluku umcigingaluku.",
        "translation": "They would sit them down down there with two wooden supports. They would sit down like this with their faces showing so that they were airtight."
    },
    "205": {
        "startTime": 1761.081,
        "endTime": 1768.253,
        "transcript": "Tua-i tau͡gken ciuqerrakun kenurrarciqerluku uqurrarmek kiingita kenurraqellruamegteki.",
        "translation": "However, they would light a little oil lamp in front of them because those were the only light they had."
    },
    "206": {
        "startTime": 1768.289,
        "endTime": 1779.131,
        "transcript": "Qagken enet yuut piyugtain ullagluku neqrarnek ciuqerranun unavet qantamek piluteng payugqelluku-gguq.",
        "translation": "The people who wanted to from the houses outside would bring him food by putting a bowl down there in front of him."
    },
    "207": {
        "startTime": 1779.149,
        "endTime": 1785.178,
        "transcript": "Wagg'uq tuqumalriateng nerutesqelluki tamakunek pitullrukait.",
        "translation": "They said they would do that to feed their dead."
    },
    "208": {
        "startTime": 1785.187,
        "endTime": 1802.602,
        "transcript": "Tua-i-llu pamani caqukak taqkagnek imgulluku qillerqelluku-llu tallimanek qillernirluki inarrluku pikunegteggu uskurirluku egalerkun anlluku pikaggun.",
        "translation": "And then when his casket inland was done, they would tie him with five ties and lay him down, attach ropes, and take him out through the smokehole up there."
    },
    "209": {
        "startTime": 1802.898,
        "endTime": 1805.812,
        "transcript": "Amigkun-llu piyuunaku, egalerkun tau͡gaam.",
        "translation": "And they wouldn't do it through the door, but through the smokehole."
    },
    "210": {
        "startTime": 1806.12,
        "endTime": 1812.748,
        "transcript": "Aneskunegteggu-ll' pikaken kangirainun uivulluku elliqaqluku.",
        "translation": "And when they took him out, they would place him by revolving him around the corners."
    },
    "211": {
        "startTime": 1813.041,
        "endTime": 1815.313,
        "transcript": "Tuaten tua-i pitullruit.",
        "translation": "That's what they did with them."
    },
    "212": {
        "startTime": 1841.66,
        "endTime": 1853.089,
        "transcript": "Tuamta-llu pitsaqevkenata-gguq aipangluta mikelngurmek aulukikumta",
        "translation": "And then they said that should we marry and take care of a child"
    },
    "213": {
        "startTime": 1854.571,
        "endTime": 1865.3,
        "transcript": "Cali-gguq uumun aipamteńun angutmun cingucaqunaku. Tauna-gguq angun ayagatuuq, ayagayulriaruuq.",
        "translation": "They also said not to push them to our husbands. They said that that man travels, he is a traveler."
    },
    "214": {
        "startTime": 1865.717,
        "endTime": 1872.031,
        "transcript": "Taumek-gguq taumek mikelnguq cingutenrillaut taumun angutmun.",
        "translation": "That's why we should not push that child unto that man."
    },
    "215": {
        "startTime": 1872.321,
        "endTime": 1881.25,
        "transcript": "Tua-i-gguq kalivkinaqumta uamqerqauyaaqaa aipaqluku ikayuqerkaungamek nulirqelriik.",
        "translation": "They said that when we cannot get out of the situation, he will have to entertain the child since a married couple are supposed to help each other."
    },
    "216": {
        "startTime": 1881.849,
        "endTime": 1887.235,
        "transcript": "Tau͡gaam-gguq ayagatulriaruuq. Auluku'urcetenrillaut.",
        "translation": "But they said that he's a traveler. We should not let him take care of the child."
    },
    "217": {
        "startTime": 1887.285,
        "endTime": 1891.771,
        "transcript": "Atam-gguq nacigatuniartuq.",
        "translation": "They said that he would be sad when he leaves."
    },
    "218": {
        "startTime": 1891.821,
        "endTime": 1897.364,
        "transcript": "Ayagan atani tauna nacigayugluku assiinani.",
        "translation": "It will be bad when he's sad over his father traveling."
    },
    "219": {
        "startTime": 1898.161,
        "endTime": 1910.447,
        "transcript": "Kiituani-gguq tua-i tua-i ayallermini-llu tayima kingutmun peng'garrluku ayagacurlautekciqaa nacigyukan.",
        "translation": "They said that he will eventually start worrying about the child he left behind and have bad trips if he keeps being sad over his father leaving."
    },
    "220": {
        "startTime": 1910.624,
        "endTime": 1920.539,
        "transcript": "Tua-i tuaten angutmun cingutesqevkenaku inerqutullruitkut irniangekumta irniarput.",
        "translation": "They would admonish us against pushing our children to the husband when we have children."
    },
    "221": {
        "startTime": 1921.105,
        "endTime": 1934.689,
        "transcript": "Tuamtell' cali irniarput anglicaqumteggu tua-i-gguq enemi waniwa irniarput nayurluku aulukilriaruamta tautun ayagalriatun angutetun pivkenata",
        "translation": "And then when we raise our children, they also said that since we are the ones who stay in the house to take care of them unlike the traveling men"
    },
    "222": {
        "startTime": 1935.142,
        "endTime": 1941.685,
        "transcript": "Irniarput enem iluani murilkurararkaugarput-gguq.",
        "translation": "They said that we should always watch our children in the house."
    },
    "223": {
        "startTime": 1941.746,
        "endTime": 1948.275,
        "transcript": "Inerciigatellra-llu-gguq anagulluku inerciigalucia pivkenaku.",
        "translation": "And they said not to excessively react to them when they're mischievous."
    },
    "224": {
        "startTime": 1948.308,
        "endTime": 1954.965,
        "transcript": "Pingiinarqut-gguq inerciigataqameng anagulluki taqsuqupaka'arqaceteng.",
        "translation": "They said that they worsen when we get too exasperated with them."
    },
    "225": {
        "startTime": 1954.971,
        "endTime": 1965.4,
        "transcript": "Cali-llu-gguq nunutukumta erinavut tapirviituq. Yagtaarpek'naku tauna irniarput. Yagiravkenaku.",
        "translation": "They also said that in reprimanding, we don't need to add to our voices. Do not hit our child. Do not hit him."
    },
    "226": {
        "startTime": 1965.419,
        "endTime": 1968.719,
        "transcript": "Yagirakumteńi-gguq cacetuciquq.",
        "translation": "They said that if we hit him, he will become overconfident."
    },
    "227": {
        "startTime": 1968.919,
        "endTime": 1976.976,
        "transcript": "Cali-llu-gguq anagulluku qanpagapakaqumteńi cacetuluni. Tua-i-gguq cacetucararkaqerput tauna irniarput.",
        "translation": "They also said that if we shout at them too much, he'll be overconfident. They said we'll make our child overconfident."
    },
    "228": {
        "startTime": 1977.575,
        "endTime": 1982.389,
        "transcript": "Taumek-am call' qanruyuteput ilangqertut arnani.",
        "translation": "That's included in women's traditional wisdom."
    },
    "229": {
        "startTime": 1982.413,
        "endTime": 1990.17,
        "transcript": "Tua-i-gguq tauna cacetucarciqerput wangkuta irniarput anagulluku qanpagaqu'rqumteggu.",
        "translation": "They said that we will make our child overconfident if we shout at them too much."
    },
    "230": {
        "startTime": 1990.999,
        "endTime": 1995.856,
        "transcript": "Tua-i niicuunani inerqungramteńi assiinani.",
        "translation": "He will behave badly, being disobedient though we admonish him."
    },
    "231": {
        "startTime": 1996.152,
        "endTime": 2004.366,
        "transcript": "Cali-ll' inerciigalkan anagulluku call' inerciigatellra pivakaqumteńi arcariinarluni.",
        "translation": "And if he's mischievous, if we react too excessively, his mischievous behavior will get worse."
    },
    "232": {
        "startTime": 2004.966,
        "endTime": 2010.637,
        "transcript": "Taumek-gguq qaruarrluku tau͡gaam mikelnguq piaqluku canrituq.",
        "translation": "That's why they say it's better to encourage a child."
    },
    "233": {
        "startTime": 2010.745,
        "endTime": 2018.545,
        "transcript": "Tuamta-llu-gguq nunutukumta yuk tamarmi, yuk-gguq tamarmi eqneruuq.",
        "translation": "And then they said that when we reprimand them, they said that all people can be irritating."
    },
    "234": {
        "startTime": 2018.578,
        "endTime": 2024.121,
        "transcript": "Tua-i-gguq irniani kenkerrlainayuitaa. Taqsuqnarqaqan nunutua.",
        "translation": "They said that they don't always treat a child with love. They reprimand him when he becomes tiresome."
    },
    "235": {
        "startTime": 2024.146,
        "endTime": 2027.446,
        "transcript": "They said that we will reprimand them.",
        "translation": "They said that we will reprimand them."
    },
    "236": {
        "startTime": 2027.531,
        "endTime": 2032.102,
        "transcript": "Nunurraarluku-llu-gguq ngelaksugutevkenaku uitalluku.",
        "translation": "THey said that after reprimanding him, do not laugh but leave him be."
    },
    "237": {
        "startTime": 2032.247,
        "endTime": 2036.789,
        "transcript": "Tua-i uitalluku qanruteksaunaku nunuqumteggu.",
        "translation": "Leave him alone without saying anything if we reprimand him."
    },
    "238": {
        "startTime": 2037.536,
        "endTime": 2043.079,
        "transcript": "Tua-i assirikan tau͡gaam nutaan assirluku piluku nunurraarluku.",
        "translation": "Only when he gets better, speak well to him after reprimanding him."
    },
    "239": {
        "startTime": 2043.126,
        "endTime": 2049.983,
        "transcript": "Qiakan tua-i tuaten engelallagatevkenaku-llu nunurraarluku.",
        "translation": "If he cries, do laugh at him like that after reprimanding him."
    },
    "240": {
        "startTime": 2049.986,
        "endTime": 2054.143,
        "transcript": "Engelallagaskumteńi-gguq cali assiiruciiquq.",
        "translation": "They said that he will become bad if we laugh at him."
    },
    "241": {
        "startTime": 2054.356,
        "endTime": 2059.17,
        "transcript": "Engelallagacimalriit-gguq call' assiitaqut mikelnguut.",
        "translation": "They also say that children who are laughed at become bad."
    },
    "242": {
        "startTime": 2060.24,
        "endTime": 2071.154,
        "transcript": "Tuaten-am call' mikelngurmek anglicarillerkamteńek enem iluani taumek aipirluku tamana tuaten pillerkarput",
        "translation": "THey would include that in the things we should do when we raise that child in the house"
    },
    "243": {
        "startTime": 2071.814,
        "endTime": 2078.843,
        "transcript": "Mikelnguum anglicallra qacignarqenrilami anglicarturallra.",
        "translation": "Because it's not easy to raise a child."
    },
    "244": {
        "startTime": 2079.708,
        "endTime": 2087.794,
        "transcript": "Makuggnaqluni. Wangkuta avani makugtellruukut anglicallemteńi irniaput.",
        "translation": "It's hard work. We worked hard back then when we raised our children."
    },
    "245": {
        "startTime": 2087.81,
        "endTime": 2093.482,
        "transcript": "Mat'um-llu nalliinitun ayuqellrunritut irniaput anglicallemteńi.",
        "translation": "And they were not like how it is now when we raised our children."
    },
    "246": {
        "startTime": 2093.803,
        "endTime": 2098.661,
        "transcript": "Terr'ilitarnek egciurluta pillrunritukut.",
        "translation": "We didn't keep throwing diapers away."
    },
    "247": {
        "startTime": 2098.714,
        "endTime": 2102.143,
        "transcript": "Taumek qanruyuteput amllellruut tua-i.",
        "translation": "That's why we had a lot of traditional wisdom."
    },
    "248": {
        "startTime": 2102.164,
        "endTime": 2105.478,
        "transcript": "Qavaryunqegkumta-llu teq'iciqniluta.",
        "translation": "And if we sleep too much, they would urinate on us."
    },
    "249": {
        "startTime": 2105.52,
        "endTime": 2112.52,
        "transcript": "Irniarput tauna tua-i aciminun qurrmarluni teq'iluta-llu, teq'icugninaqluni.",
        "translation": "That child will urinate on his mat and urinate on us, and it will smell like urine."
    },
    "250": {
        "startTime": 2112.529,
        "endTime": 2115.114,
        "transcript": "Maa-i assiryunqepialriaci.",
        "translation": "Now you try to be spick and span."
    },
    "251": {
        "startTime": 2115.244,
        "endTime": 2122.701,
        "transcript": "Tua-i-gguq qavaryunqegkumta enevut teq'icugninarqeciquq irniamta tepiinek",
        "translation": "They said that if we sleep too much, our house will smell like our child's urine"
    },
    "252": {
        "startTime": 2123.055,
        "endTime": 2126.298,
        "transcript": "Tua-i unugmi qurruciyuilamteńi.",
        "translation": "Because we don't let them relieve themselves at night."
    },
    "253": {
        "startTime": 2126.481,
        "endTime": 2132.796,
        "transcript": "Irniaput qavamteńek makluta qurrucirluki qurrutaitnun qurrevkatullruaput unugmi.",
        "translation": "Waking from our sleep, we would have our children urinate in the urine buckets at night."
    },
    "254": {
        "startTime": 2132.931,
        "endTime": 2137.702,
        "transcript": "Makcamta-llu qurrutii teguluku anluta ciqilluku.",
        "translation": "And when we got up, we would take his urine bucket, go out, and dump it."
    },
    "255": {
        "startTime": 2138.283,
        "endTime": 2145.183,
        "transcript": "Iqairturyarat-wa terr'ilitait iqairturluki terr'ilitarkarugailata-llu",
        "translation": "And we would always wash their reusable diapers because they didn't have a lot"
    },
    "256": {
        "startTime": 2145.191,
        "endTime": 2153.248,
        "transcript": "Terr'ilitarkairtelaata wanikuaqan iqairturluki pikalinrilngurni wangkuta terr'ilitait.",
        "translation": "Because they would run out of diapers, we who didn't have a lot would wash them later."
    },
    "257": {
        "startTime": 2153.741,
        "endTime": 2157.269,
        "transcript": "Taumek tua-i tuaten qanruyutengqertukut.",
        "translation": "That is our traditional wisdom."
    },
    "258": {
        "startTime": 2183.126,
        "endTime": 2188.711,
        "transcript": "Tua-i una call' waniw' kenka arcaqerluku qanruyutnguuq.",
        "translation": "And then love is also an important part of traditional wisdom."
    },
    "259": {
        "startTime": 2189.955,
        "endTime": 2195.383,
        "transcript": "Ilamta pingraakut angu akinauresqevkenaku.",
        "translation": "No matter what our peers do to us, never retaliate."
    },
    "260": {
        "startTime": 2195.529,
        "endTime": 2202.886,
        "transcript": "Tuamtell' allaneruar tekiskan camiunguciilengraan ilaliuresqelluku.",
        "translation": "Then if a visitor comes, be sociable with him even if you don't know where he's from."
    },
    "261": {
        "startTime": 2203.053,
        "endTime": 2205.353,
        "transcript": "Wii takartapiallruunga.",
        "translation": "I was very shy."
    },
    "262": {
        "startTime": 2205.823,
        "endTime": 2223.866,
        "transcript": "Caperqepiallruaqa man'a waten piaqatnga: \"Nutaan tangengerpegu ilaliuraqluku. Allaneq-llu nutaan tangengerpegu pikailkan qanrrarpenek ciunurluku qanrrarpenek qalarulluku, wall' pikangqerqan nerqertelluku.\"",
        "translation": "I would be very daunted when they said this to me: \"Even if you see him for the first time, socialie with him. And even if you see a guest for the first time, welcome him with your mouth and talk to him if you don't have anything else, or feed him if there's enough for him.\""
    },
    "263": {
        "startTime": 2223.9,
        "endTime": 2226.628,
        "transcript": "Takartapialrianga-wa wiinga.",
        "translation": "I was very shy."
    },
    "264": {
        "startTime": 2226.974,
        "endTime": 2237.102,
        "transcript": "Tua-i-gguq tamaa-i tamana qanrraminek-llu ilaliurturluku wall'u nerqertelluku tungelqurturyaquq-gguq yuk.",
        "translation": "They said that through socializing by talking or feeding him, a person becomes a close friend."
    },
    "265": {
        "startTime": 2237.129,
        "endTime": 2241.372,
        "transcript": "Ilakliulluki tua-i tamakut ilaliuqallni.",
        "translation": "They become friends with those they socialized with."
    },
    "266": {
        "startTime": 2241.39,
        "endTime": 2248.618,
        "transcript": "Iliin-gguq yuum, yuk-gguq caperrsugluni nunanun tekitetuuq, ilumuuluni-llu.",
        "translation": "They say that some people are daunted when going to villages, and it's true."
    },
    "267": {
        "startTime": 2251.137,
        "endTime": 2260.508,
        "transcript": "Tamaa-i tamakut qalaruyutek'lalput ilumun yugnun tekitelluq caperrnarquq tekitesailkeḿinun.",
        "translation": "Those things that we talked about are true, that it's difficult to go to places where one has not gone before."
    },
    "268": {
        "startTime": 2260.623,
        "endTime": 2268.951,
        "transcript": "Taumek nallukvut nani tangeqsailkevvut elluarrluku cali ciuniurarkaqliniarput.",
        "translation": "That is why we must give a warm welcome to someone we don't know whom we've never seen anywhere before."
    },
    "269": {
        "startTime": 2269.055,
        "endTime": 2274.855,
        "transcript": "Tua-i-gguq tauna caperrsugtuq ciunerkani nalluamiu.",
        "translation": "They said that he is daunted since he doesn't know where he's going."
    },
    "270": {
        "startTime": 2274.964,
        "endTime": 2279.007,
        "transcript": "Ciunerkani nalluamiki capeqluki taukut nunat.",
        "translation": "He's daunted by that village because he doesn't know the place he's going to."
    },
    "271": {
        "startTime": 2279.317,
        "endTime": 2285.96,
        "transcript": "Tuaten ayuquq. Ciunerkaput tekitaanrilkemteńun ayagaqamta caperrsutuukut.",
        "translation": "That's what it's like. When we travel where we haven't before, we're daunted."
    },
    "272": {
        "startTime": 2286.451,
        "endTime": 2291.208,
        "transcript": "Taumek maa-i man'a ayagyuani elpeci umyuaqerkarci.",
        "translation": "That's why you young people should remember this."
    },
    "273": {
        "startTime": 2291.317,
        "endTime": 2300.503,
        "transcript": "Cali-llu ilarraci ilavci pingraiceci angu pillruniluci piqaqsaunaki.",
        "translation": "Also, even if what family you have does anything to you, never retaliate with their wrong against you as your motive."
    },
    "274": {
        "startTime": 2300.529,
        "endTime": 2307.786,
        "transcript": "Cali-llu angayuqaput qigcikesqelluki qanrucimatullruukut.",
        "translation": "We were also told to respect our parents."
    },
    "275": {
        "startTime": 2307.99,
        "endTime": 2313.375,
        "transcript": "Taumek angayuqertuumalriani cali maa-i makut qanruyutellrenka.",
        "translation": "That's why to you who still have parents, these are the wisdom passed down to me."
    },
    "276": {
        "startTime": 2313.475,
        "endTime": 2322.203,
        "transcript": "Angayuqaput takaqerkauluki, qigcikluki, qanruyukariit-llu maligtaqungnaqluku.",
        "translation": "We must defer to our parents, respect them, and try to adhere to their traditional wisdom."
    },
    "277": {
        "startTime": 2322.318,
        "endTime": 2325.776,
        "transcript": "Tuaten qanrucimallruukut wangkuta.",
        "translation": "That's what we were told."
    },
    "278": {
        "startTime": 2325.84,
        "endTime": 2329.697,
        "transcript": "Taumek anglicarteput qigcignarqellruut.",
        "translation": "That's why we respected those who raised us."
    },
    "279": {
        "startTime": 2331.137,
        "endTime": 2336.38,
        "transcript": "Maa-i makut wii ellangellemni qanruyutellrenka.",
        "translation": "This is the traditional passed down to me when I was growing up."
    },
    "280": {
        "startTime": 2336.738,
        "endTime": 2341.852,
        "transcript": "Qanruyuteput tang, yuum qanruyutii amllepialria.",
        "translation": "Our traditional wisdom, there is a lot of wisdom for a person."
    },
    "281": {
        "startTime": 2342.695,
        "endTime": 2346.266,
        "transcript": "Tua-i ca tamarmi qanruyutetarluni.",
        "translation": "There is traditional wisdom for everything."
    },
    "282": {
        "startTime": 2347.367,
        "endTime": 2353.824,
        "transcript": "Qanrutketukumteki qanrumalaryartukut. Ca tamarmi qanruyutegnqertuq.",
        "translation": "If we spoke about them, we would speak a lot. There is traditional wisdom for everything."
    },
    "283": {
        "startTime": 2353.957,
        "endTime": 2362.743,
        "transcript": "Maa-i makut arcaqerluki wii qanruyutellrenka tamakut tamaa-i neqalleruaraam murilkellerkaa",
        "translation": "Those are the important wisdom that was passed down to me, how to take care of fish"
    },
    "284": {
        "startTime": 2362.781,
        "endTime": 2367.295,
        "transcript": "Cali-ll' tua-i ilamta pingraakut kenekluki",
        "translation": "And loving our peers no matter what they do to us"
    },
    "285": {
        "startTime": 2367.831,
        "endTime": 2372.731,
        "transcript": "Kia-ll' pingraakut akinauyuunaku pillerkarput.",
        "translation": "And not retaliating no matter what anyone does to us."
    },
    "286": {
        "startTime": 2397.968,
        "endTime": 2410.64,
        "transcript": "Tutgaramni elpeci paiciryaramci nang'arkaunrilngurmek umyuaqekuvciu paiciryaramci qanruyutmek.",
        "translation": "I would pass down what will never cease to you, my grandchildren, if you would remember it, I would pass down traditional wisdom to you."
    },
    "287": {
        "startTime": 2412.718,
        "endTime": 2418.461,
        "transcript": "Waniw' qanertua ava-i ilaci kenkarkaugaci.",
        "translation": "I just said that you must love your peers."
    },
    "288": {
        "startTime": 2418.782,
        "endTime": 2428.497,
        "transcript": "Kia pingraaci kenekluki. Kitumun-llu pilarniluci tauna tuaten piksaunaku tau͡gaam ayuqluku kenekluki.",
        "translation": "Treat even those who do wrong to you with love. And do not do the same to those who wrong you, but treat them with love."
    },
    "289": {
        "startTime": 2429.824,
        "endTime": 2433.934,
        "transcript": "Tamaa-i paiciutekarci maa-i man' kenka.",
        "translation": "This love is what you must pass down."
    },
    "290": {
        "startTime": 2434.464,
        "endTime": 2441.444,
        "transcript": "Then, love your peers, and depend on your god.",
        "translation": "Then, love your peers, and depend on your god."
    },
    "291": {
        "startTime": 2441.729,
        "endTime": 2445.899,
        "transcript": "Tamaa-i paiciutekaqaqa elpeceńun tutgaramnun.",
        "translation": "Now, I am passing it on to you, my grandchildren."
    },
    "292": {
        "startTime": 2446.109,
        "endTime": 2450.509,
        "transcript": "Tua-i-ll' kankut tutgaraanka ilaci kankut",
        "translation": "And then my grandchildren down there, your relatives down there"
    },
    "293": {
        "startTime": 2451.984,
        "endTime": 2460.564,
        "transcript": "Qanrut'laranka tamaklaita ayuqucirluki paitaqesqessaaqluku qanruyun.",
        "translation": "I tell every one of them, teaching them so that they would pass down the traditional wisdom."
    },
    "294": {
        "startTime": 2460.779,
        "endTime": 2466.949,
        "transcript": "Maaken ayange'rma tangenrrilngerpecia umyuaqelaasqessaaqluku.",
        "translation": "Even if I go and you do not see my, I want you to remember it."
    },
    "295": {
        "startTime": 2467.039,
        "endTime": 2478.039,
        "transcript": "Qanrut'laranka ertet tamaita qaillun ilait anelgukarait-llu kenekluki pisqelluki wall'u anelgutkenrilengraitki",
        "translation": "I tell them at the dawn of every day to treat their families, their siblings, with love, or even if they're not siblings"
    },
    "296": {
        "startTime": 2478.164,
        "endTime": 2483.094,
        "transcript": "Wall'u ilaita pingraitki akinauyuitesqelluki.",
        "translation": "Or to never retaliate no matter what their peers do to them."
    },
    "297": {
        "startTime": 2483.274,
        "endTime": 2488.544,
        "transcript": "Cali-llu qanleravkenaki pisqelluki.",
        "translation": "Also, I tell them not to speak harshly."
    },
    "298": {
        "startTime": 2489.174,
        "endTime": 2493.034,
        "transcript": "Iciw' tua-i qanqataitesqevkenaci.",
        "translation": "You know, not to speak without thinking."
    },
    "299": {
        "startTime": 2493.309,
        "endTime": 2499.399,
        "transcript": "Qanqatailkuvci umyuarniutmun tekitelarciquci.",
        "translation": "If you speak without thinking, you will regret it someday."
    },
    "300": {
        "startTime": 2499.679,
        "endTime": 2503.989,
        "transcript": "Tamaa-i taman' paiciutekaqa umyuaqelararkarci.",
        "translation": "You must remember that which I passed down to you."
    },
    "301": {
        "startTime": 2506.419,
        "endTime": 2513.419,
        "transcript": "Maaken ayange'rma tua-i umyuaqelararkauluki elpeci. Tua-i paitaqluku.",
        "translation": "Even if I go from here, you must remember them. That is how I pass them down."
    },
    "302": {
        "startTime": 2537.464,
        "endTime": 2547.944,
        "transcript": "Arnat allakarmeng waten cikuvailgan-llu uptenglallruit anguteteng.",
        "translation": "Women would separately prepare their men before it froze like this."
    },
    "303": {
        "startTime": 2548.039,
        "endTime": 2552.809,
        "transcript": "Atu'urkaitnek, pilugugkaitnek.",
        "translation": "Clothes and skin boots for them."
    },
    "304": {
        "startTime": 2553.119,
        "endTime": 2562.079,
        "transcript": "Makunek-llu cali waten neqet qeciitnek, taryaqvagnek",
        "translation": "And these fish skins like this, the king salmon skins"
    },
    "305": {
        "startTime": 2563.434,
        "endTime": 2566.724,
        "transcript": "Apeqmeggnek-gguq neqairiluteng.",
        "translation": "They called it preparing fish skins."
    },
    "306": {
        "startTime": 2566.724,
        "endTime": 2571.254,
        "transcript": "Tuaten pitullruut amirarkiurqamegteki.",
        "translation": "That's what they did when they made them fish skin boots."
    },
    "307": {
        "startTime": 2571.624,
        "endTime": 2582.674,
        "transcript": "Cali-am tamakut waten tua-i kemgit au͡g'aqainarraarpek'naki",
        "translation": "Also, they wouldn't just remove the flesh"
    },
    "308": {
        "startTime": 2582.904,
        "endTime": 2592.964,
        "transcript": "Taqngamegteki tamakut kemgit au͡gaumariaqata egmianun cali caliaqevkenaki",
        "translation": "When they finished removing the flesh, they wouldn't work on them right away"
    },
    "309": {
        "startTime": 2593.549,
        "endTime": 2604.659,
        "transcript": "Waten cali teq'umun akurrluki pitullruit tamakut neqet qeciit.",
        "translation": "They would submerge the fish skins into urine like this."
    },
    "310": {
        "startTime": 2607.139,
        "endTime": 2609.279,
        "transcript": "Neqcugniirulluki.",
        "translation": "They removed the fish smell."
    },
    "311": {
        "startTime": 2609.734,
        "endTime": 2616.364,
        "transcript": "Makut maa-i waten wagg'uq teq'iciriaqameng",
        "translation": "When they were aging urine, as they called it"
    },
    "312": {
        "startTime": 2618.894,
        "endTime": 2630.504,
        "transcript": "Canun tua-i assigtaitnun, nutem assigtaitnun angutait tamaavet qurrmatullruut.",
        "translation": "Their men would urinate into those containers, their original containers."
    },
    "313": {
        "startTime": 2630.514,
        "endTime": 2633.174,
        "transcript": "Wagg'uq teq'iciriluteng.",
        "translation": "They called that aging urine."
    },
    "314": {
        "startTime": 2633.329,
        "endTime": 2636.679,
        "transcript": "Tua-i teqsaqnaurtut tamakut cakneq.",
        "translation": "Those would smell very strong."
    },
    "315": {
        "startTime": 2637.389,
        "endTime": 2644.959,
        "transcript": "Tua-i tamakunun akurrluki tamakut neqet qeciit pitullruit.",
        "translation": "They would submerge the fish skins into those."
    },
    "316": {
        "startTime": 2645.189,
        "endTime": 2653.839,
        "transcript": "Nutaan-llu tua-i akungqarraarluki keligarluki, keligaucirluki.",
        "translation": "And then after soaking them, they would scrape them."
    },
    "317": {
        "startTime": 2653.839,
        "endTime": 2662.749,
        "transcript": "Ayallanun pirraarluki nutaan ellamun agarrluki kinercirluki.",
        "translation": "After working on them with boards, hang them outside and dry them."
    },
    "318": {
        "startTime": 2662.859,
        "endTime": 2675.979,
        "transcript": "Tua-i-llu nutaan kinraki tamakut tamaa-i tamakunun angutmeggnun piluguliluki.",
        "translation": "Then when they're dry, them make those into skin boots for their men."
    },
    "319": {
        "startTime": 2676.074,
        "endTime": 2680.994,
        "transcript": "Wagg'uq amiraliluki waten ayagassuucirluki.",
        "translation": "They said they made them fish skin boots for their travels."
    },
    "320": {
        "startTime": 2706.099,
        "endTime": 2711.009,
        "transcript": "Makut cali angutait cali upluteng.",
        "translation": "Their men would also prepare."
    },
    "321": {
        "startTime": 2712.499,
        "endTime": 2720.869,
        "transcript": "Imkunek can'giircuutnek cali tamakut pinriata imkut taluyarpagnek pitullrit",
        "translation": "When they no longer needed those big fish traps that are used to catch blackfish"
    },
    "322": {
        "startTime": 2721.259,
        "endTime": 2731.289,
        "transcript": "Makunek maa-i can'giirnek cali cimiqata'arqamegteki",
        "translation": "When they were going to change from the blackfish"
    },
    "323": {
        "startTime": 2731.529,
        "endTime": 2740.089,
        "transcript": "Nutaan tamakunek call' taluyiluteng pitullruut.",
        "translation": "They would also make those fish traps."
    },
    "324": {
        "startTime": 2744.384,
        "endTime": 2750.484,
        "transcript": "Tua-i-llu nutaan cali civcimariitki",
        "translation": "And then when they started setting them"
    },
    "325": {
        "startTime": 2751.439,
        "endTime": 2764.729,
        "transcript": "Maa-i mat'um nalliini canek can'giiret waten assigtalaraput piciatun yaassiillernek missuullernek-llu.",
        "translation": "These days, we store blackfish in various things like boxes and burlap bags."
    },
    "326": {
        "startTime": 2765.659,
        "endTime": 2774.599,
        "transcript": "Tau͡gken au͡gkut murilkellrenka anglicartelput tamakunek pitaitellruut.",
        "translation": "However, our caretakers that I observed back then didn't have those."
    },
    "327": {
        "startTime": 2800.404,
        "endTime": 2813.144,
        "transcript": "Makut maa-i arnait cali tamakunek canegnek caqukaitnek uptetullruut",
        "translation": "Their women also used to prepare containers for them with that grass"
    },
    "328": {
        "startTime": 2813.149,
        "endTime": 2819.739,
        "transcript": "Waten tua-i cungakvaunrirqata, qakingaqata.",
        "translation": "When they weren't green like this anymore, when they were getting pale."
    },
    "329": {
        "startTime": 2820.049,
        "endTime": 2823.819,
        "transcript": "Amlleriluki waten quyurrluki.",
        "translation": "They gathered a lot like this."
    },
    "330": {
        "startTime": 2827.929,
        "endTime": 2830.989,
        "transcript": "Cali-llu waten kiagmi...",
        "translation": "And in the summer like this..."
    },
    "331": {
        "startTime": 2831.904,
        "endTime": 2834.224,
        "transcript": "Kituriqalliniunga.",
        "translation": "I forgot to say something."
    },
    "332": {
        "startTime": 2834.729,
        "endTime": 2846.909,
        "transcript": "Uptelallruit arnat tamakut pikameggnek tamakut can'get kelugkaitnek, kelugkaitnek-wa tua-i pissuutekaitnek.",
        "translation": "Those women would prepare that grass to use for stitching, what they would use for stitching."
    },
    "333": {
        "startTime": 2849.464,
        "endTime": 2861.414,
        "transcript": "Au͡gkut anglicartelput ingna tekitarkaq waten umyuaqerrlainarluku pitullruut",
        "translation": "Those who raised us back then always did things for the future that they were heading towards."
    },
    "334": {
        "startTime": 2861.574,
        "endTime": 2868.834,
        "transcript": "Ingna tekitarkaq atu'urkateng yaaqsingraan upyuterrlainarluku.",
        "translation": "They always prepared what they would need even if the time they would need it was far ahead in the future."
    },
    "335": {
        "startTime": 2868.879,
        "endTime": 2878.059,
        "transcript": "Camek-wa tua-i piilameng. Maani tau͡gaam makunek nunam qainganelngurnek aklungqellruut.",
        "translation": "It was because they didn't have anything else. What they had was only from the land here."
    },
    "336": {
        "startTime": 2880.024,
        "endTime": 2885.154,
        "transcript": "Tua-i pinricunaunateng tamakut ellaitni piaqluteng.",
        "translation": "They did that because they couldn't afford not to."
    },
    "337": {
        "startTime": 2887.204,
        "endTime": 2894.614,
        "transcript": "Una tua-i tekitarkaurtaqan pissuutekaa una yaaqsigluku amna upyutaqluki.",
        "translation": "They would prepare what they would need way ahead of time."
    },
    "338": {
        "startTime": 2895.344,
        "endTime": 2903.584,
        "transcript": "Kiagmi maa-i iitaat can'get kelugkaqluki pitullruit.",
        "translation": "They would gather tall cottongrass in the summer for stitching."
    },
    "339": {
        "startTime": 2903.929,
        "endTime": 2908.019,
        "transcript": "Arnat iitartaangaqameng tamakunek",
        "translation": "When the women started gathering those tall cottongrass"
    },
    "340": {
        "startTime": 2908.149,
        "endTime": 2915.449,
        "transcript": "Tua-i-llu nutaan saggluki waten apeqmeggnek nalacirluki.",
        "translation": "And then they would spread them out like this to dry them, as they called it."
    },
    "341": {
        "startTime": 2915.814,
        "endTime": 2929.004,
        "transcript": "Tua-i-llu nutaan tamakunek piameng apeqmeggnek naliita kinraki quyurtevkenaki-am cali tupigturluki.",
        "translation": "And then when they were dried, nalaluteng as they called it, they wouldn't gather them, but weave them."
    },
    "342": {
        "startTime": 2930.584,
        "endTime": 2933.634,
        "transcript": "Nutaan-llu taqngamegteki imegluki.",
        "translation": "Then when they were finished, they rolled them up."
    },
    "343": {
        "startTime": 2933.724,
        "endTime": 2939.364,
        "transcript": "Tuaten pitullruit tamakut can'get kelugkait.",
        "translation": "That's what they did with that grass they used for stitching."
    },
    "344": {
        "startTime": 2940.779,
        "endTime": 2948.149,
        "transcript": "Au͡gkut ava-i wangkuta mat'um nalliini-w' tua-i umyuaqaqamki",
        "translation": "These days, when I remember those things that we did back then"
    },
    "345": {
        "startTime": 2949.059,
        "endTime": 2954.499,
        "transcript": "Tua-i wiinga-llu tamana atullerkaa capeqsagulluku.",
        "translation": "Even I find it difficult to imagine doing that."
    },
    "346": {
        "startTime": 2987.964,
        "endTime": 2992.244,
        "transcript": "Tua-i-llu nutaan cali makut angutait",
        "translation": "And then their men"
    },
    "347": {
        "startTime": 2995.429,
        "endTime": 3007.779,
        "transcript": "Makunek cali pissuutekameggnek makunek imarmiutarcuutekameggnek taluyinaurtut.",
        "translation": "They would also make these mink traps that are shaped like fish traps."
    },
    "348": {
        "startTime": 3009.439,
        "endTime": 3019.269,
        "transcript": "Mikluki tua-i, qaill' waten taktaurluki, qaillun-llu tua-i waten. Kuiggaat-wa tua-i cuqluki taluyitullruut.",
        "translation": "They would make them small, about this long, and then about this size. They would measure the creeks to make traps."
    },
    "349": {
        "startTime": 3020.839,
        "endTime": 3026.919,
        "transcript": "Tamakut-am cali piciatun pivkenateng cuqerluteng cali.",
        "translation": "They also didn't do th ose haphazardly, but had measurements."
    },
    "350": {
        "startTime": 3027.634,
        "endTime": 3033.844,
        "transcript": "Makut-llu cali ilulirait waten can'giircuutetun ayuqevkenateng.",
        "translation": "And their inner funnels here were not like blackfish traps."
    },
    "351": {
        "startTime": 3033.974,
        "endTime": 3041.294,
        "transcript": "Waten pinaurtut, tua-i-llu ingna igtetun ayuqeqerluni.",
        "translation": "They would be like this, then it woud be like a den on the side."
    },
    "352": {
        "startTime": 3043.449,
        "endTime": 3053.959,
        "transcript": "Au͡gna-wa alqerma uinga tayima waten tangvaurarqamni",
        "translation": "When I would watch my older sister's husband like this"
    },
    "353": {
        "startTime": 3054.339,
        "endTime": 3066.349,
        "transcript": "Unatni tua-i waten piqerluki tauna tua-i cuq'errluku iteryararkaa, wagg'uq igyaraat piqa'aqluku.",
        "translation": "He would do this with his hands to measure the entrance, what they call the igyaraq."
    },
    "354": {
        "startTime": 3066.399,
        "endTime": 3071.039,
        "transcript": "Tuaten ayuqetullruut piciatun pivkenateng.",
        "translation": "That's what they were like, not made haphazardly."
    },
    "355": {
        "startTime": 3071.674,
        "endTime": 3083.154,
        "transcript": "Tuamtellu cali cuignilngurcuutnek cali taluyiami tuamtellu igyarait waten ayuqluki au͡g'utun",
        "translation": "And then when he made fish trap shaped land otter traps, he would make the entrance like before"
    },
    "356": {
        "startTime": 3083.519,
        "endTime": 3093.339,
        "transcript": "Tua-i-llu waten unatni cuq'errluku uumek kumluminek waten elliurluki neqututacirkiurluki.",
        "translation": "And then he would do this with his hands and measure the width with his thumb."
    },
    "357": {
        "startTime": 3093.824,
        "endTime": 3102.394,
        "transcript": "Tuaten piciatun-am cali pivkenateng tamakut pitullruut, pitullrulliniut.",
        "translation": "Those were also not made haphazardly like that."
    },
    "358": {
        "startTime": 3131.664,
        "endTime": 3143.284,
        "transcript": "Waten aarnarqellrani neplirasqevkenaki-llu cali yuilqumi pitullruit.",
        "translation": "They would also tell them not to make too much noise in the wilderness when it's dangerous like this."
    },
    "359": {
        "startTime": 3144.049,
        "endTime": 3146.409,
        "transcript": "Waten neplirasqevkenaki.",
        "translation": "They told them not to make too much noise like this."
    },
    "360": {
        "startTime": 3146.514,
        "endTime": 3159.784,
        "transcript": "Tau͡gaam imkut arenqiallugtellriit, tamaa-i tamakut kiskuneng tua-i nepliraarkauluteng.",
        "translation": "They would only make noise over those who've gotten into accidents, such as if someone drowned."
    },
    "361": {
        "startTime": 3159.864,
        "endTime": 3171.514,
        "transcript": "Inerquutekluki-am cali tamakut waten uksuarmi yuilqumi aarasqevkenata, neplirasqevkenata.",
        "translation": "They would also admonish us against shouting or making noise in the wilderness in the fall like this."
    },
    "362": {
        "startTime": 3175.134,
        "endTime": 3183.024,
        "transcript": "Tamakut-gguq tamaa-i tau͡gaam nanikualriit tuaten nepliratullruut.",
        "translation": "They said that only those in dire situations would make noise like that."
    },
    "363": {
        "startTime": 3183.234,
        "endTime": 3195.834,
        "transcript": "Tua-i-llu neplilriamek aaralriamek niiskuneng tua-i tauna taringarkauluku arenqiallugucia wall'u kis'ucia.",
        "translation": "And then if they hear someone making noise, shouting, they would understand that he has gotten into an accident or has sunk into water."
    },
    "364": {
        "startTime": 3197.531,
        "endTime": 3215.231,
        "transcript": "Tau͡gken mat'um nalliini tua-i inerquumananriameng-wa tua-i inerqurnanriamceci wangkuta caciirulluteng.",
        "translation": "These days, however, since they are no longer admonished, since we no longer admonish you, they do not act appropriately."
    },
    "365": {
        "startTime": 3216.73,
        "endTime": 3226.04,
        "transcript": "Waten-llu neplianaurtut aaraaqluteng tua-i maani nunat akuliitni.",
        "translation": "And they now make noise and shout like this between villages."
    },
    "366": {
        "startTime": 3227.29,
        "endTime": 3230.55,
        "transcript": "Inerquutektullruit.",
        "translation": "They used to admonish against that."
    },
    "367": {
        "startTime": 3258.985,
        "endTime": 3266.725,
        "transcript": "Tua-i-llu nutaan waten cali ayakata'arqameng cali",
        "translation": "Also, when they were going to travel like this"
    },
    "368": {
        "startTime": 3271.15,
        "endTime": 3277.72,
        "transcript": "Qanerrlainarluteng tamatum nuniinun ayakatarniluteng.",
        "translation": "They would always say the area they were going to."
    },
    "369": {
        "startTime": 3281.418,
        "endTime": 3296.151,
        "transcript": "Tua-i waten tekitenritaqata-llu tua-i arenqialluguciit nalluvkenaki piaqluki.",
        "translation": "And when they didn't return like this, they would know that they had gotten into an accident."
    },
    "370": {
        "startTime": 3300.073,
        "endTime": 3310.088,
        "transcript": "Tau͡gken mat'um nalliini waten ayagaaqameng maa-i angyatgun qanerpek'nateng.",
        "translation": "These days, however, they do not say anything when they're going to travel by boat."
    },
    "371": {
        "startTime": 3311.8,
        "endTime": 3321.228,
        "transcript": "Tua-i-llu tekitenrilameng, tekitenrilata qaill' tua-i ayuquciinaki qanenrilata.",
        "translation": "And then when they don't return, they don't know what happened because they didn't say anything."
    },
    "372": {
        "startTime": 3322.776,
        "endTime": 3328.262,
        "transcript": "Piciatun maa-i mat'um nalliini ayagangameng.",
        "translation": "It's because they go to random places these days."
    },
    "373": {
        "startTime": 3328.47,
        "endTime": 3335.77,
        "transcript": "Wall'u natetmurrnguarluteng nunanun-ll' allanun ayagaqluteng.",
        "translation": "Or, they pretend to go somewhere and end up traveling to other villages."
    },
    "374": {
        "startTime": 3336.247,
        "endTime": 3342.632,
        "transcript": "Tamaa-i tamatum maa-i mat'um nalliini ayuquciirucetaitkut.",
        "translation": "That's what's making us so addled these days."
    },
    "375": {
        "startTime": 3344.259,
        "endTime": 3353.83,
        "transcript": "Qaillun tua-i ukut kingunrulriit waten ayuquciinaki piaqluki.",
        "translation": "We don't know what's going with the latest generation."
    },
    "376": {
        "startTime": 3354.363,
        "endTime": 3356.835,
        "transcript": "Wall'u tuancukluki.",
        "translation": "Or, we think they're someplace."
    },
    "377": {
        "startTime": 3358.264,
        "endTime": 3367.878,
        "transcript": "Maa-i mat'um nalliini yuilqumi-llu tua-i tuqungraata qaillun ayuquciitaqluki.",
        "translation": "Even when they die in the wilderness these days, we have no idea about them."
    },
    "378": {
        "startTime": 3394.94,
        "endTime": 3410.411,
        "transcript": "Watua maa-i ayagyugaat makut wii wangkuta ayagyugaullerput civuqlia, civuqliani-gga tau͡ga maa-i makut kinguqliput wangkuta ayagyugaullret uniurteqapiggluku pilriit.",
        "translation": "The young people these days have completely left behind what we were like before we were young, these young descendants of ours."
    },
    "379": {
        "startTime": 3410.758,
        "endTime": 3414.329,
        "transcript": "Cameng enuqitenritellrata arcaqaqai.",
        "translation": "They're worse because they don't lack anything."
    },
    "380": {
        "startTime": 3414.583,
        "endTime": 3419.468,
        "transcript": "Wangkuta ayagyugaullemteńi ca tamalkuan nuuqluku pillruamteggu.",
        "translation": "Because we lacked everything when we were young."
    },
    "381": {
        "startTime": 3419.919,
        "endTime": 3424.491,
        "transcript": "Aturat, neqkat-llu tamalkuita, cat tamalkuita nuuqluki.",
        "translation": "We lacked clothes, all food, and everything."
    },
    "382": {
        "startTime": 3424.77,
        "endTime": 3432.241,
        "transcript": "Tau͡gken-am maa-i mat'um nalliini makut tan'gurraat kinguqliput ca tamalkuan nallulriatun ayuqluku.",
        "translation": "However, these boys, our descandants, these days are like they don't know anything at all."
    },
    "383": {
        "startTime": 3432.253,
        "endTime": 3436.668,
        "transcript": "Makut civuqliit pingnatullrat nalluluku.",
        "translation": "They don't know how our ancestors survived."
    },
    "384": {
        "startTime": 3437.524,
        "endTime": 3444.724,
        "transcript": "Ca tamalkuan piyukengarteng tamalkuan aturyuk'ngarteng tegutaarluku pillruameng, pingengameng.",
        "translation": "It's because they've started taking anything they want and need."
    },
    "385": {
        "startTime": 3444.729,
        "endTime": 3452.82,
        "transcript": "Wangkuta-am maa-i civuqliani qayatgurrlainaq tau͡gaam pitullrulriakut anguarturluta.",
        "translation": "In the past, we only traveled by rowing kayaks."
    },
    "386": {
        "startTime": 3453.662,
        "endTime": 3458.113,
        "transcript": "Massiinameng ataucirqaungraan tangyuitellruunga wii tamaani.",
        "translation": "I never saw motors even once back then."
    },
    "387": {
        "startTime": 3458.522,
        "endTime": 3461.168,
        "transcript": "Enengqerrluta-llu mud house.",
        "translation": "And we had mud houses."
    },
    "388": {
        "startTime": 3461.505,
        "endTime": 3466.768,
        "transcript": "Kass'ameng-ll' ataucirquungraan tangyuunii. Kass'at nurqapiggluta.",
        "translation": "And I never saw a Caucasian even once. The Caucasians completely missed us."
    },
    "389": {
        "startTime": 3467.849,
        "endTime": 3475.91,
        "transcript": "Tau͡gken-am maa-i mat'um nalliini Kass'at amlleriata makut-ll' ayagyugaat tan'gurraat qaillun ayuqliriluteng.",
        "translation": "These days, however, since there are a lot of Caucasians now, these young boys have become strange."
    },
    "390": {
        "startTime": 3476.857,
        "endTime": 3483.503,
        "transcript": "Mat'um arcaqerluki merkam piyukai. Uyviirutellriatun ayuqekai merkam.",
        "translation": "This alcohol especially affects them. Alcohol makes them foolish."
    },
    "391": {
        "startTime": 3484.448,
        "endTime": 3494.285,
        "transcript": "Umyugarraa iliini navguraqaa tau͡gaten pissiyaagpakaraqata, man'a erneqegtaar Agayutem cikiutii iqluggun aturpakaraqatgu.",
        "translation": "He sometimes destroys his mind when he does that too much, when they do too much wrong in this day that God gave."
    },
    "392": {
        "startTime": 3494.609,
        "endTime": 3498.227,
        "transcript": "Qaneqsaunii umyugaqa tau͡ga navguraquq taumun.",
        "translation": "My mindset is destroyed when I don't speak on that."
    },
    "393": {
        "startTime": 3498.586,
        "endTime": 3503.041,
        "transcript": "Cali una atanerput nunuutekqapiggluku piaqatgu.",
        "translation": "Also, when they heavily scold in the name of our lord."
    },
    "394": {
        "startTime": 3503.453,
        "endTime": 3510.29,
        "transcript": "Wanigga ellaitngulriani iliini umyugaqa qanernaqsaaquq waten umyugarturluni:",
        "translation": "For those, my mind sometimes wants to speak thinking like this:"
    },
    "395": {
        "startTime": 3510.455,
        "endTime": 3516.874,
        "transcript": "\"Wangkutnun taqellrunritukut. Agayutem piliaqelqaakut. Tauna pinrilengramku canrituq.\"",
        "translation": "\"We were not made for ourselves. God made us. It'll be okay if I don't do that.\""
    },
    "396": {
        "startTime": 3548.903,
        "endTime": 3558.565,
        "transcript": "Wanigga elpeci tan'gu'rni tamalkurpeci niitellriani, niicugnilriani una tau͡ga umyugaqerniarci:",
        "translation": "Now, all you boys who hear and are listening now, remember this:"
    },
    "397": {
        "startTime": 3559.004,
        "endTime": 3568.422,
        "transcript": "\"Elpeneng yuurtellrunrituten. Agayutem tau͡gaam caliaqelqaaten, yuurcitelqaaten ellii yuknaluten.",
        "translation": "\"You were not born of yourself. God, instead, made you, and had you born to be his child."
    },
    "398": {
        "startTime": 3568.687,
        "endTime": 3576.824,
        "transcript": "\"Tau͡gken elpeneng maa-i ayatmun pilriaten. Cali elpeneng picurlatmun piaqelriaten.",
        "translation": "\"However, you stray by yourself. You also bring yourself to misfortune."
    },
    "399": {
        "startTime": 3578.535,
        "endTime": 3589.923,
        "transcript": "\"Kia yuum uqisqiangaitaaten maa-i yuungnaqurallerpeni elliin avatiikun. Agayutem tau͡gaam uqisqiumaciqaaten kaigakuvet tan'gu'rni elpeci.\"",
        "translation": "\"No person will shelter you as you live aside from him. Only God will shelter you if you boys ask for it.\""
    },
    "400": {
        "startTime": 3590.166,
        "endTime": 3596.01,
        "transcript": "Maa-i niicugnilriani tamalkurpeci qanrutnaamci. Niiskicia.",
        "translation": "Let me tell all of you who are listening now. Hear me."
    },
    "401": {
        "startTime": 3596.183,
        "endTime": 3603.383,
        "transcript": "Imumi makuneng pingvailemta yuut assiq'apiarallruut tamalkurmeng.",
        "translation": "Back before we had these Western things, every single person was extremely good."
    },
    "402": {
        "startTime": 3604.615,
        "endTime": 3613.365,
        "transcript": "Cameng-gga tua-i qiruanarqelriameng, imkucilriameng-gga paqricilriameng-llu niitnaunateng.",
        "translation": "They wouldn't hear about saddening news or, you know, people going missing."
    },
    "403": {
        "startTime": 3613.706,
        "endTime": 3623.551,
        "transcript": "Maa-i tau͡gken nalluvci maa-i tan'gurraat makut niicugnilriani ca tamalkurmi piciqaangaanariluni.",
        "translation": "Now, however, to you boys who are listening now, everything has become commonplace."
    },
    "404": {
        "startTime": 3624.521,
        "endTime": 3631.599,
        "transcript": "Ca tamak'acagarmi piciqaangaanariluni ca ellicurlakallerkaa cailkamun pinariluni.",
        "translation": "Every single thing has become commonplace, even misplacing something in a random place."
    },
    "405": {
        "startTime": 3631.812,
        "endTime": 3634.89,
        "transcript": "Elliqalria ak'a-llu tayim' cataunani.",
        "translation": "When it's put, it's already as good as gone."
    },
    "406": {
        "startTime": 3635.171,
        "endTime": 3640.982,
        "transcript": "Tamana umyugaqekuvgu Agayutem piliaqellra tamakut ilangciyuunaki yuuyartuten.",
        "translation": "If you remember that God made it, you would live by ignoring those."
    },
    "407": {
        "startTime": 3641.586,
        "endTime": 3647.342,
        "transcript": "Kitak' wanigga elluarrluten yuungnaquraqina wanigg' wanigga waken ayagluten.",
        "translation": "Now, try to live righteously from this very moment."
    }
};